import {gnosis,polygon,polygonAmoy,chiliz,spicy,base,baseSepolia}from'viem/chains';import gql from'graphql-tag';import {getMarketKey,getMarketName,getMarketDescription,dictionaries,getSelectionName}from'@azuro-org/dictionaries';import {parseUnits,formatUnits}from'viem';var Environment;
(function (Environment) {
    Environment["GnosisDevXDAI"] = "GnosisDevXDAI";
    Environment["GnosisXDAI"] = "GnosisXDAI";
    Environment["PolygonUSDT"] = "PolygonUSDT";
    // PolygonAmoyAZUSD = 'PolygonAmoyAZUSD',
    Environment["PolygonAmoyUSDT"] = "PolygonAmoyUSDT";
    Environment["ChilizWCHZ"] = "ChilizWCHZ";
    Environment["ChilizSpicyWCHZ"] = "ChilizSpicyWCHZ";
    Environment["BaseWETH"] = "BaseWETH";
    Environment["BaseSepoliaWETH"] = "BaseSepoliaWETH";
})(Environment || (Environment = {}));
const environments = {
    [gnosis.id]: Environment.GnosisXDAI,
    [polygon.id]: Environment.PolygonUSDT,
    [polygonAmoy.id]: Environment.PolygonAmoyUSDT,
    [chiliz.id]: Environment.ChilizWCHZ,
    [spicy.id]: Environment.ChilizSpicyWCHZ,
    [base.id]: Environment.BaseWETH,
    [baseSepolia.id]: Environment.BaseSepoliaWETH,
};var lpAbi = [
    {
        'inputs': [
            {
                'internalType': 'uint64',
                'name': 'waitTime',
                'type': 'uint64',
            },
        ],
        'name': 'ClaimTimeout',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'CoreNotActive',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectAmount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectCoreState',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectFee',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectLegacyLP',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectMinBet',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectMinDepo',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectReinforcementAbility',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectRelayer',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidInitialization',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'LiquidityNotOwned',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'LockedBetToken',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'LockedLiquidityComboLimitReached',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'LockedLiquidityLimitReached',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NotInitializing',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OnlyFactory',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'OwnableInvalidOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'OwnableUnauthorizedAccount',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'enum SafeCast.Type',
                'name': 'to',
                'type': 'uint8',
            },
        ],
        'name': 'SafeCastError',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SmallBet',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SmallDepo',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'UnknownCore',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint64',
                'name': 'waitTime',
                'type': 'uint64',
            },
        ],
        'name': 'WithdrawalTimeout',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'newAffilaite',
                'type': 'address',
            },
        ],
        'name': 'AffiliateChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'amount',
                'type': 'uint256',
            },
        ],
        'name': 'BettorWin',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'newClaimTimeout',
                'type': 'uint64',
            },
        ],
        'name': 'ClaimTimeoutChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'enum ILP.CoreState',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'reinforcementAbility',
                'type': 'uint64',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'reinforcementAbilityCombo',
                'type': 'uint64',
            },
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'minBet',
                'type': 'uint128',
            },
        ],
        'name': 'CoreSettingsUpdated',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'newDataProvider',
                'type': 'address',
            },
        ],
        'name': 'DataProviderChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'depositor',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
            {
                'indexed': false,
                'internalType': 'uint48[]',
                'name': 'oldDepositIds',
                'type': 'uint48[]',
            },
        ],
        'name': 'DepositsMigrated',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'enum ILP.FeeType',
                'name': 'feeType',
                'type': 'uint8',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'fee',
                'type': 'uint64',
            },
        ],
        'name': 'FeeChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'version',
                'type': 'uint64',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'legacyLP',
                'type': 'address',
            },
        ],
        'name': 'LegacyLPSet',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'amount',
                'type': 'uint256',
            },
        ],
        'name': 'LiquidityAdded',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
            {
                'indexed': false,
                'internalType': 'uint40',
                'name': 'percent',
                'type': 'uint40',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'amount',
                'type': 'uint256',
            },
        ],
        'name': 'LiquidityRemoved',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'newMinDepo',
                'type': 'uint128',
            },
        ],
        'name': 'MinDepoChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'relayer',
                'type': 'address',
            },
        ],
        'name': 'RelayerSet',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'newWithdrawTimeout',
                'type': 'uint64',
            },
        ],
        'name': 'WithdrawTimeoutChanged',
        'type': 'event',
    },
    {
        'inputs': [],
        'name': 'access',
        'outputs': [
            {
                'internalType': 'contract IAccess',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
        ],
        'name': 'addCore',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'name': 'addDeposit',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'name': 'addDepositFor',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint128',
                'name': 'lockedReserve',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'finalReserve',
                'type': 'uint128',
            },
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'name': 'addReserve',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'affiliate',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'betOwner',
                        'type': 'address',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'gameId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'enum IOrder.ConditionKind',
                                'name': 'conditionKind',
                                'type': 'uint8',
                            },
                            {
                                'internalType': 'uint64[]',
                                'name': 'odds',
                                'type': 'uint64[]',
                            },
                            {
                                'internalType': 'uint128[]',
                                'name': 'outcomes',
                                'type': 'uint128[]',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'potentialLossLimit',
                                'type': 'uint128',
                            },
                            {
                                'internalType': 'uint8',
                                'name': 'winningOutcomesCount',
                                'type': 'uint8',
                            },
                        ],
                        'internalType': 'struct IOrder.ConditionData[]',
                        'name': 'conditionDatas',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'enum IOrder.BetType',
                        'name': 'betType',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'clientBetData',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'bettorSignature',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'oracleSignature',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IOrder.OrderData',
                'name': 'order',
                'type': 'tuple',
            },
            {
                'internalType': 'address',
                'name': 'betOwner',
                'type': 'address',
            },
            {
                'internalType': 'bytes',
                'name': 'data',
                'type': 'bytes',
            },
        ],
        'name': 'betOrder',
        'outputs': [
            {
                'internalType': 'uint256[]',
                'name': '',
                'type': 'uint256[]',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newAffiliate',
                'type': 'address',
            },
        ],
        'name': 'changeAffiliate',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint64',
                'name': 'newClaimTimeout',
                'type': 'uint64',
            },
        ],
        'name': 'changeClaimTimeout',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newDataProvider',
                'type': 'address',
            },
        ],
        'name': 'changeDataProvider',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'enum ILP.FeeType',
                'name': 'feeType',
                'type': 'uint8',
            },
            {
                'internalType': 'uint64',
                'name': 'newFee',
                'type': 'uint64',
            },
        ],
        'name': 'changeFee',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'int128',
                'name': 'deltaReserve',
                'type': 'int128',
            },
            {
                'internalType': 'bool',
                'name': 'isCombo',
                'type': 'bool',
            },
        ],
        'name': 'changeLockedLiquidity',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint128',
                'name': 'newMinDepo',
                'type': 'uint128',
            },
        ],
        'name': 'changeMinDepo',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint64',
                'name': 'newWithdrawTimeout',
                'type': 'uint64',
            },
        ],
        'name': 'changeWithdrawTimeout',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'target',
                'type': 'address',
            },
            {
                'internalType': 'bytes4',
                'name': 'selector',
                'type': 'bytes4',
            },
        ],
        'name': 'checkAccess',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
        ],
        'name': 'checkCore',
        'outputs': [],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner_',
                'type': 'address',
            },
        ],
        'name': 'checkOwner',
        'outputs': [],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'claimReward',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'claimedAmount',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'claimTimeout',
        'outputs': [
            {
                'internalType': 'uint64',
                'name': '',
                'type': 'uint64',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'name': 'cores',
        'outputs': [
            {
                'internalType': 'enum ILP.CoreState',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'internalType': 'uint64',
                'name': 'reinforcementAbility',
                'type': 'uint64',
            },
            {
                'internalType': 'uint64',
                'name': 'reinforcementAbilityCombo',
                'type': 'uint64',
            },
            {
                'internalType': 'uint128',
                'name': 'minBet',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'lockedLiquidity',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'lockedLiquidityCombo',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'dataProvider',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'factory',
        'outputs': [
            {
                'internalType': 'contract IOwnable',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'fees',
        'outputs': [
            {
                'internalType': 'uint64',
                'name': '',
                'type': 'uint64',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'getLastDepositId',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
        ],
        'name': 'getLockedLiquidityLimit',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'maxLiquidity',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'maxLiquidityCombo',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'access_',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'vault_',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'dataProvider_',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'affiliate_',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': 'minDepo_',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'daoFee',
                'type': 'uint64',
            },
            {
                'internalType': 'uint64',
                'name': 'dataProviderFee',
                'type': 'uint64',
            },
            {
                'internalType': 'uint64',
                'name': 'affiliateFee',
                'type': 'uint64',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'depositId',
                'type': 'uint256',
            },
        ],
        'name': 'isDepositExists',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'legacyLP',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint48[]',
                'name': 'oldDepositIds',
                'type': 'uint48[]',
            },
        ],
        'name': 'migrateDeposits',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'minDepo',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'relayer',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'renounceOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'name': 'rewards',
        'outputs': [
            {
                'internalType': 'int128',
                'name': 'amount',
                'type': 'int128',
            },
            {
                'internalType': 'uint64',
                'name': 'claimedAt',
                'type': 'uint64',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'legacyLP_',
                'type': 'address',
            },
        ],
        'name': 'setLegacyLP',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'relayer_',
                'type': 'address',
            },
        ],
        'name': 'setRelayer',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'token',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
            {
                'internalType': 'enum ILP.CoreState',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'internalType': 'uint64',
                'name': 'reinforcementAbility',
                'type': 'uint64',
            },
            {
                'internalType': 'uint64',
                'name': 'reinforcementAbilityCombo',
                'type': 'uint64',
            },
            {
                'internalType': 'uint128',
                'name': 'minBet',
                'type': 'uint128',
            },
        ],
        'name': 'updateCoreSettings',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'vault',
        'outputs': [
            {
                'internalType': 'contract IVault',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'viewPayout',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48',
            },
        ],
        'name': 'withdrawAfter',
        'outputs': [
            {
                'internalType': 'uint64',
                'name': '',
                'type': 'uint64',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
            {
                'internalType': 'uint40',
                'name': 'percent',
                'type': 'uint40',
            },
        ],
        'name': 'withdrawDeposit',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'withdrawnAmount',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'withdrawPayout',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
            {
                'internalType': 'uint256[]',
                'name': 'tokenIds',
                'type': 'uint256[]',
            },
        ],
        'name': 'withdrawPayouts',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'withdrawTimeout',
        'outputs': [
            {
                'internalType': 'uint64',
                'name': '',
                'type': 'uint64',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'stateMutability': 'payable',
        'type': 'receive',
    },
];var coreAbi = [
    {
        'inputs': [],
        'stateMutability': 'nonpayable',
        'type': 'constructor',
    },
    {
        'inputs': [],
        'name': 'AlreadyPaid',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'AlreadyRejected',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'BetNotExists',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'CobmoBetNotResolved',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ComboBetResolvedPartially',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionAlreadyResolved',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionNotFinished',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ConditionNotRunning',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'outcomeId',
                'type': 'uint256',
            },
        ],
        'name': 'DuplicateOutcomes',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ECDSAInvalidSignature',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'length',
                'type': 'uint256',
            },
        ],
        'name': 'ECDSAInvalidSignatureLength',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'bytes32',
                'name': 's',
                'type': 'bytes32',
            },
        ],
        'name': 'ECDSAInvalidSignatureS',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectAffiliate',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectAmount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectBetType',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectBetsConditionsCount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectConditionId',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectConditionIds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectOutcomeId',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectOutcomesCount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectSettleDate',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectSubBetsToReset',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectWinningOutcomesCount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidBettorSignature',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidChainId',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidInitialization',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidNonce',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidOracleSignature',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NotInitializing',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OddsTooSmall',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OnlyLp',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'name': 'OnlyOracle',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'OwnableInvalidOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'OwnableUnauthorizedAccount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'PotentialLossLimit',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'enum SafeCast.Type',
                'name': 'to',
                'type': 'uint8',
            },
        ],
        'name': 'SafeCastError',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SignatureExpired',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SmallBet',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'SubBetConditionResolved',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'SubBetDuplicated',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'WrongOutcome',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'BetRejected',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'gameId',
                'type': 'uint256',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint128[]',
                'name': 'outcomes',
                'type': 'uint128[]',
            },
            {
                'indexed': false,
                'internalType': 'uint64[]',
                'name': 'odds',
                'type': 'uint64[]',
            },
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'winningOutcomesCount',
                'type': 'uint8',
            },
        ],
        'name': 'ConditionCreated',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint8',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'indexed': false,
                'internalType': 'uint128[]',
                'name': 'winningOutcomes',
                'type': 'uint128[]',
            },
            {
                'indexed': false,
                'internalType': 'int128',
                'name': 'lpProfit',
                'type': 'int128',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'settledAt',
                'type': 'uint64',
            },
        ],
        'name': 'ConditionResolved',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [],
        'name': 'EIP712DomainChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'version',
                'type': 'uint64',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'affiliate',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'enum IOrder.BetType',
                'name': 'betType',
                'type': 'uint8',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'nonce',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'gameId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'conditionId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'enum IOrder.ConditionKind',
                        'name': 'conditionKind',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'outcomeId',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'odds',
                        'type': 'uint64',
                    },
                ],
                'indexed': false,
                'internalType': 'struct ILiveCore.SubBetData[]',
                'name': 'betDatas',
                'type': 'tuple[]',
            },
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'potentialLossLimit',
                'type': 'uint128',
            },
        ],
        'name': 'NewLiveBet',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'inputs': [],
        'name': 'azuroBet',
        'outputs': [
            {
                'internalType': 'contract IAzuroBet',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'bets',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'payout',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128',
                'name': 'outcomeId',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'timestamp',
                'type': 'uint64',
            },
            {
                'internalType': 'bool',
                'name': 'isPaid',
                'type': 'bool',
            },
            {
                'internalType': 'uint48',
                'name': 'lastDepositId',
                'type': 'uint48',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256[]',
                'name': 'conditionIds',
                'type': 'uint256[]',
            },
        ],
        'name': 'cancelConditions',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'conditions',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'totalNetBets',
                'type': 'uint128',
            },
            {
                'internalType': 'uint64',
                'name': 'settledAt',
                'type': 'uint64',
            },
            {
                'internalType': 'uint48',
                'name': 'lastDepositId',
                'type': 'uint48',
            },
            {
                'internalType': 'uint8',
                'name': 'winningOutcomesCount',
                'type': 'uint8',
            },
            {
                'internalType': 'enum ILiveCore.ConditionState',
                'name': 'state',
                'type': 'uint8',
            },
            {
                'internalType': 'address',
                'name': 'oracle',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'eip712Domain',
        'outputs': [
            {
                'internalType': 'bytes1',
                'name': 'fields',
                'type': 'bytes1',
            },
            {
                'internalType': 'string',
                'name': 'name',
                'type': 'string',
            },
            {
                'internalType': 'string',
                'name': 'version',
                'type': 'string',
            },
            {
                'internalType': 'uint256',
                'name': 'chainId',
                'type': 'uint256',
            },
            {
                'internalType': 'address',
                'name': 'verifyingContract',
                'type': 'address',
            },
            {
                'internalType': 'bytes32',
                'name': 'salt',
                'type': 'bytes32',
            },
            {
                'internalType': 'uint256[]',
                'name': 'extensions',
                'type': 'uint256[]',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'betOwner',
                        'type': 'address',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'gameId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'enum IOrder.ConditionKind',
                                'name': 'conditionKind',
                                'type': 'uint8',
                            },
                            {
                                'internalType': 'uint64[]',
                                'name': 'odds',
                                'type': 'uint64[]',
                            },
                            {
                                'internalType': 'uint128[]',
                                'name': 'outcomes',
                                'type': 'uint128[]',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'potentialLossLimit',
                                'type': 'uint128',
                            },
                            {
                                'internalType': 'uint8',
                                'name': 'winningOutcomesCount',
                                'type': 'uint8',
                            },
                        ],
                        'internalType': 'struct IOrder.ConditionData[]',
                        'name': 'conditionDatas',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'enum IOrder.BetType',
                        'name': 'betType',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'clientBetData',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'bettorSignature',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'oracleSignature',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IOrder.OrderData',
                'name': 'order',
                'type': 'tuple',
            },
        ],
        'name': 'getClientData',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'string',
                        'name': 'attention',
                        'type': 'string',
                    },
                    {
                        'internalType': 'address',
                        'name': 'affiliate',
                        'type': 'address',
                    },
                    {
                        'internalType': 'address',
                        'name': 'core',
                        'type': 'address',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'expiresAt',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'chainId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'relayerFeeAmount',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isFeeSponsored',
                        'type': 'bool',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isBetSponsored',
                        'type': 'bool',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isSponsoredBetReturnable',
                        'type': 'bool',
                    },
                ],
                'internalType': 'struct IOrder.ClientData',
                'name': 'clientData',
                'type': 'tuple',
            },
        ],
        'stateMutability': 'pure',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'getCondition',
        'outputs': [
            {
                'components': [
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'time',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'tokenId',
                                'type': 'uint256',
                            },
                        ],
                        'internalType': 'struct ILiveCore.TimeBet[]',
                        'name': 'timeBets',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'uint128[]',
                        'name': 'payouts',
                        'type': 'uint128[]',
                    },
                    {
                        'internalType': 'uint128',
                        'name': 'totalNetBets',
                        'type': 'uint128',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'settledAt',
                        'type': 'uint64',
                    },
                    {
                        'internalType': 'uint48',
                        'name': 'lastDepositId',
                        'type': 'uint48',
                    },
                    {
                        'internalType': 'uint8',
                        'name': 'winningOutcomesCount',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'enum ILiveCore.ConditionState',
                        'name': 'state',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                ],
                'internalType': 'struct ILiveCore.Condition',
                'name': '',
                'type': 'tuple',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'betOwner',
                        'type': 'address',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'gameId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'enum IOrder.ConditionKind',
                                'name': 'conditionKind',
                                'type': 'uint8',
                            },
                            {
                                'internalType': 'uint64[]',
                                'name': 'odds',
                                'type': 'uint64[]',
                            },
                            {
                                'internalType': 'uint128[]',
                                'name': 'outcomes',
                                'type': 'uint128[]',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'potentialLossLimit',
                                'type': 'uint128',
                            },
                            {
                                'internalType': 'uint8',
                                'name': 'winningOutcomesCount',
                                'type': 'uint8',
                            },
                        ],
                        'internalType': 'struct IOrder.ConditionData[]',
                        'name': 'conditionDatas',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'enum IOrder.BetType',
                        'name': 'betType',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'clientBetData',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'bettorSignature',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'oracleSignature',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IOrder.OrderData',
                'name': 'order',
                'type': 'tuple',
            },
        ],
        'name': 'getOrderBetsAmounts',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'totalAmount',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128[]',
                'name': 'amounts',
                'type': 'uint128[]',
            },
        ],
        'stateMutability': 'pure',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint128',
                'name': 'outcomeId',
                'type': 'uint128',
            },
        ],
        'name': 'getOutcomeIndex',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'azuroBet_',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'lp_',
                'type': 'address',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
        ],
        'name': 'isConditionCanceled',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'conditionId',
                'type': 'uint256',
            },
            {
                'internalType': 'uint128',
                'name': 'outcome',
                'type': 'uint128',
            },
        ],
        'name': 'isOutcomeWinning',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'lp',
        'outputs': [
            {
                'internalType': 'contract ILP',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'name': 'nonces',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'betOwner',
                        'type': 'address',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'gameId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'enum IOrder.ConditionKind',
                                'name': 'conditionKind',
                                'type': 'uint8',
                            },
                            {
                                'internalType': 'uint64[]',
                                'name': 'odds',
                                'type': 'uint64[]',
                            },
                            {
                                'internalType': 'uint128[]',
                                'name': 'outcomes',
                                'type': 'uint128[]',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'potentialLossLimit',
                                'type': 'uint128',
                            },
                            {
                                'internalType': 'uint8',
                                'name': 'winningOutcomesCount',
                                'type': 'uint8',
                            },
                        ],
                        'internalType': 'struct IOrder.ConditionData[]',
                        'name': 'conditionDatas',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'enum IOrder.BetType',
                        'name': 'betType',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'clientBetData',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'bettorSignature',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'oracleSignature',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IOrder.OrderData',
                'name': 'order',
                'type': 'tuple',
            },
            {
                'internalType': 'address',
                'name': 'betOwner',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'minBet',
                'type': 'uint256',
            },
            {
                'internalType': 'bytes',
                'name': 'data',
                'type': 'bytes',
            },
        ],
        'name': 'putOrder',
        'outputs': [
            {
                'internalType': 'uint256[]',
                'name': '',
                'type': 'uint256[]',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'conditionId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint256[]',
                        'name': 'tokenIds',
                        'type': 'uint256[]',
                    },
                ],
                'internalType': 'struct ILiveCore.RejectedBet[]',
                'name': 'bets_',
                'type': 'tuple[]',
            },
        ],
        'name': 'rejectBets',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'tokenId',
                        'type': 'uint256',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'outcomeId',
                                'type': 'uint128',
                            },
                        ],
                        'internalType': 'struct ILiveCore.ComboSubBet[]',
                        'name': 'subBets',
                        'type': 'tuple[]',
                    },
                ],
                'internalType': 'struct ILiveCore.RejectedComboBet[]',
                'name': 'bets_',
                'type': 'tuple[]',
            },
        ],
        'name': 'rejectComboBets',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'renounceOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'uint256',
                        'name': 'conditionId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint128[]',
                        'name': 'winningOutcomes',
                        'type': 'uint128[]',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'settledAt',
                        'type': 'uint64',
                    },
                ],
                'internalType': 'struct ILiveCore.ResolveData[]',
                'name': 'resolveData',
                'type': 'tuple[]',
            },
        ],
        'name': 'resolveConditions',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'resolvePayout',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'viewPayout',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
];var azuroBetAbi = [
    {
        'inputs': [],
        'name': 'ERC721EnumerableForbiddenBatchMint',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'sender',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'ERC721IncorrectOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'ERC721InsufficientApproval',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'approver',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidApprover',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidOperator',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'receiver',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidReceiver',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'sender',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidSender',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'ERC721NonexistentToken',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'index',
                'type': 'uint256',
            },
        ],
        'name': 'ERC721OutOfBoundsIndex',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidInitialization',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NotInitializing',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OnlyCore',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'OwnableInvalidOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'OwnableUnauthorizedAccount',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'approved',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'Approval',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'approved',
                'type': 'bool',
            },
        ],
        'name': 'ApprovalForAll',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'version',
                'type': 'uint64',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'Transfer',
        'type': 'event',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'approve',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'balanceOf',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'baseURI',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'burn',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'core',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'getApproved',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner_',
                'type': 'address',
            },
        ],
        'name': 'getTokensByOwner',
        'outputs': [
            {
                'internalType': 'uint256[]',
                'name': 'tokenIds',
                'type': 'uint256[]',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner_',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'start',
                'type': 'uint256',
            },
            {
                'internalType': 'uint256',
                'name': 'count',
                'type': 'uint256',
            },
        ],
        'name': 'getTokensByOwner',
        'outputs': [
            {
                'internalType': 'uint256[]',
                'name': 'tokenIds',
                'type': 'uint256[]',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'core_',
                'type': 'address',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
        ],
        'name': 'isApprovedForAll',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'lastTokenId',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'mint',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'name',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'ownerOf',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'renounceOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'safeTransferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'internalType': 'bytes',
                'name': 'data',
                'type': 'bytes',
            },
        ],
        'name': 'safeTransferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
            {
                'internalType': 'bool',
                'name': 'approved',
                'type': 'bool',
            },
        ],
        'name': 'setApprovalForAll',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'string',
                'name': 'uri',
                'type': 'string',
            },
        ],
        'name': 'setBaseURI',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'bytes4',
                'name': 'interfaceId',
                'type': 'bytes4',
            },
        ],
        'name': 'supportsInterface',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'symbol',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'index',
                'type': 'uint256',
            },
        ],
        'name': 'tokenByIndex',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'index',
                'type': 'uint256',
            },
        ],
        'name': 'tokenOfOwnerByIndex',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'tokenURI',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'totalSupply',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'transferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
];var cashoutAbi = [
    {
        'inputs': [],
        'name': 'BetAlreadyPaid',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'BetAlreadyResolved',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'BetNotOwned',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'BetOwnerSignatureExpired',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'BettingContractNotAllowed',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ComboBetResolving',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ECDSAInvalidSignature',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'length',
                'type': 'uint256',
            },
        ],
        'name': 'ECDSAInvalidSignatureLength',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'bytes32',
                'name': 's',
                'type': 'bytes32',
            },
        ],
        'name': 'ECDSAInvalidSignatureS',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'EnforcedPause',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ExpectedPause',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InsufficientBalance',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidBetOwnerSignature',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidChainId',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidInitialization',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidOdds',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidOddsCount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidOracleSignature',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NotInitializing',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NothingChanged',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'OwnableInvalidOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'OwnableUnauthorizedAccount',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'bettingContract',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'betOwner',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'betId',
                'type': 'uint256',
            },
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'odds',
                'type': 'uint64',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'payout',
                'type': 'uint256',
            },
        ],
        'name': 'BetCashedOut',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'bettingContract',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'betToken',
                'type': 'address',
            },
        ],
        'name': 'BettingContractUpdated',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [],
        'name': 'EIP712DomainChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'version',
                'type': 'uint64',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'isOracle',
                'type': 'bool',
            },
        ],
        'name': 'OracleUpdated',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'Paused',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'Unpaused',
        'type': 'event',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'betOwner',
                'type': 'address',
            },
            {
                'components': [
                    {
                        'internalType': 'string',
                        'name': 'attention',
                        'type': 'string',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'chainId',
                        'type': 'uint256',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'betId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'address',
                                'name': 'bettingContract',
                                'type': 'address',
                            },
                            {
                                'internalType': 'uint64',
                                'name': 'minOdds',
                                'type': 'uint64',
                            },
                        ],
                        'internalType': 'struct ICashOut.CashOutItem[]',
                        'name': 'items',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'uint64',
                        'name': 'expiresAt',
                        'type': 'uint64',
                    },
                ],
                'internalType': 'struct ICashOut.CashOutOrder',
                'name': 'order',
                'type': 'tuple',
            },
            {
                'internalType': 'uint64[]',
                'name': 'odds',
                'type': 'uint64[]',
            },
            {
                'internalType': 'bytes',
                'name': 'betOwnerSignature',
                'type': 'bytes',
            },
            {
                'internalType': 'bytes',
                'name': 'oracleSignature',
                'type': 'bytes',
            },
        ],
        'name': 'cashOutBets',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'eip712Domain',
        'outputs': [
            {
                'internalType': 'bytes1',
                'name': 'fields',
                'type': 'bytes1',
            },
            {
                'internalType': 'string',
                'name': 'name',
                'type': 'string',
            },
            {
                'internalType': 'string',
                'name': 'version',
                'type': 'string',
            },
            {
                'internalType': 'uint256',
                'name': 'chainId',
                'type': 'uint256',
            },
            {
                'internalType': 'address',
                'name': 'verifyingContract',
                'type': 'address',
            },
            {
                'internalType': 'bytes32',
                'name': 'salt',
                'type': 'bytes32',
            },
            {
                'internalType': 'uint256[]',
                'name': 'extensions',
                'type': 'uint256[]',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'contract IERC20',
                'name': 'payoutToken_',
                'type': 'address',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'name': 'isOracle',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'pause',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'paused',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'renounceOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'unpause',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'bettingContract',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'betToken',
                'type': 'address',
            },
        ],
        'name': 'updateBettingContract',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
            {
                'internalType': 'bool',
                'name': 'isOracle_',
                'type': 'bool',
            },
        ],
        'name': 'updateOracle',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'token',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'value',
                'type': 'uint256',
            },
        ],
        'name': 'withdrawToken',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
];var relayerAbi = [
    {
        'inputs': [],
        'stateMutability': 'nonpayable',
        'type': 'constructor',
    },
    {
        'inputs': [],
        'name': 'IncorrectAddress',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidInitialization',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NotInitializing',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OnlyPaymaster',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'OwnableInvalidOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'OwnableUnauthorizedAccount',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'relayer',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'affiliate',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'bettor',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'core',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'uint256[]',
                'name': 'tokenIds',
                'type': 'uint256[]',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'amount',
                'type': 'uint256',
            },
        ],
        'name': 'FeeSponsored',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'version',
                'type': 'uint64',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'payMaster',
                'type': 'address',
            },
        ],
        'name': 'PayMasterChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'relayer',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'uint256',
                'name': 'amount',
                'type': 'uint256',
            },
        ],
        'name': 'RelayerRewarded',
        'type': 'event',
    },
    {
        'inputs': [],
        'name': '_CLIENTBETDATA_TYPEHASH',
        'outputs': [
            {
                'internalType': 'bytes32',
                'name': '',
                'type': 'bytes32',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': '_CLIENTDATA_TYPEHASH',
        'outputs': [
            {
                'internalType': 'bytes32',
                'name': '',
                'type': 'bytes32',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': '_COMBOPART_TYPE_TYPEHASH',
        'outputs': [
            {
                'internalType': 'bytes32',
                'name': '',
                'type': 'bytes32',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': '_SUBBET_TYPEHASH',
        'outputs': [
            {
                'internalType': 'bytes32',
                'name': '',
                'type': 'bytes32',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'betOwner',
                        'type': 'address',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'gameId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'enum IOrder.ConditionKind',
                                'name': 'conditionKind',
                                'type': 'uint8',
                            },
                            {
                                'internalType': 'uint64[]',
                                'name': 'odds',
                                'type': 'uint64[]',
                            },
                            {
                                'internalType': 'uint128[]',
                                'name': 'outcomes',
                                'type': 'uint128[]',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'potentialLossLimit',
                                'type': 'uint128',
                            },
                            {
                                'internalType': 'uint8',
                                'name': 'winningOutcomesCount',
                                'type': 'uint8',
                            },
                        ],
                        'internalType': 'struct IOrder.ConditionData[]',
                        'name': 'conditionDatas',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'enum IOrder.BetType',
                        'name': 'betType',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'clientBetData',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'bettorSignature',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'oracleSignature',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IOrder.OrderData[]',
                'name': 'orders',
                'type': 'tuple[]',
            },
        ],
        'name': 'betFor',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'relayExecutor',
                'type': 'address',
            },
            {
                'components': [
                    {
                        'internalType': 'string',
                        'name': 'attention',
                        'type': 'string',
                    },
                    {
                        'internalType': 'address',
                        'name': 'affiliate',
                        'type': 'address',
                    },
                    {
                        'internalType': 'address',
                        'name': 'core',
                        'type': 'address',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'expiresAt',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'chainId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'relayerFeeAmount',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isFeeSponsored',
                        'type': 'bool',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isBetSponsored',
                        'type': 'bool',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isSponsoredBetReturnable',
                        'type': 'bool',
                    },
                ],
                'internalType': 'struct IOrder.ClientData',
                'name': 'data',
                'type': 'tuple',
            },
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'betOwner',
                        'type': 'address',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'gameId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'enum IOrder.ConditionKind',
                                'name': 'conditionKind',
                                'type': 'uint8',
                            },
                            {
                                'internalType': 'uint64[]',
                                'name': 'odds',
                                'type': 'uint64[]',
                            },
                            {
                                'internalType': 'uint128[]',
                                'name': 'outcomes',
                                'type': 'uint128[]',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'potentialLossLimit',
                                'type': 'uint128',
                            },
                            {
                                'internalType': 'uint8',
                                'name': 'winningOutcomesCount',
                                'type': 'uint8',
                            },
                        ],
                        'internalType': 'struct IOrder.ConditionData[]',
                        'name': 'conditionDatas',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'enum IOrder.BetType',
                        'name': 'betType',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'clientBetData',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'bettorSignature',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'oracleSignature',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IOrder.OrderData',
                'name': 'order',
                'type': 'tuple',
            },
            {
                'internalType': 'address',
                'name': 'betOwner',
                'type': 'address',
            },
            {
                'internalType': 'bytes',
                'name': 'hashes',
                'type': 'bytes',
            },
        ],
        'name': 'betOrder',
        'outputs': [
            {
                'internalType': 'uint256[]',
                'name': 'tokenIds',
                'type': 'uint256[]',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'payMaster_',
                'type': 'address',
            },
        ],
        'name': 'changePayMaster',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'betOwner',
                        'type': 'address',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'gameId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'enum IOrder.ConditionKind',
                                'name': 'conditionKind',
                                'type': 'uint8',
                            },
                            {
                                'internalType': 'uint64[]',
                                'name': 'odds',
                                'type': 'uint64[]',
                            },
                            {
                                'internalType': 'uint128[]',
                                'name': 'outcomes',
                                'type': 'uint128[]',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'potentialLossLimit',
                                'type': 'uint128',
                            },
                            {
                                'internalType': 'uint8',
                                'name': 'winningOutcomesCount',
                                'type': 'uint8',
                            },
                        ],
                        'internalType': 'struct IOrder.ConditionData[]',
                        'name': 'conditionDatas',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'enum IOrder.BetType',
                        'name': 'betType',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'clientBetData',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'bettorSignature',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'oracleSignature',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IOrder.OrderData',
                'name': 'order',
                'type': 'tuple',
            },
        ],
        'name': 'getClientData',
        'outputs': [
            {
                'components': [
                    {
                        'internalType': 'string',
                        'name': 'attention',
                        'type': 'string',
                    },
                    {
                        'internalType': 'address',
                        'name': 'affiliate',
                        'type': 'address',
                    },
                    {
                        'internalType': 'address',
                        'name': 'core',
                        'type': 'address',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'expiresAt',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'chainId',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'uint256',
                        'name': 'relayerFeeAmount',
                        'type': 'uint256',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isFeeSponsored',
                        'type': 'bool',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isBetSponsored',
                        'type': 'bool',
                    },
                    {
                        'internalType': 'bool',
                        'name': 'isSponsoredBetReturnable',
                        'type': 'bool',
                    },
                ],
                'internalType': 'struct IOrder.ClientData',
                'name': 'clientData',
                'type': 'tuple',
            },
        ],
        'stateMutability': 'pure',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'components': [
                    {
                        'internalType': 'address',
                        'name': 'betOwner',
                        'type': 'address',
                    },
                    {
                        'components': [
                            {
                                'internalType': 'uint256',
                                'name': 'gameId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'uint256',
                                'name': 'conditionId',
                                'type': 'uint256',
                            },
                            {
                                'internalType': 'enum IOrder.ConditionKind',
                                'name': 'conditionKind',
                                'type': 'uint8',
                            },
                            {
                                'internalType': 'uint64[]',
                                'name': 'odds',
                                'type': 'uint64[]',
                            },
                            {
                                'internalType': 'uint128[]',
                                'name': 'outcomes',
                                'type': 'uint128[]',
                            },
                            {
                                'internalType': 'uint128',
                                'name': 'potentialLossLimit',
                                'type': 'uint128',
                            },
                            {
                                'internalType': 'uint8',
                                'name': 'winningOutcomesCount',
                                'type': 'uint8',
                            },
                        ],
                        'internalType': 'struct IOrder.ConditionData[]',
                        'name': 'conditionDatas',
                        'type': 'tuple[]',
                    },
                    {
                        'internalType': 'enum IOrder.BetType',
                        'name': 'betType',
                        'type': 'uint8',
                    },
                    {
                        'internalType': 'address',
                        'name': 'oracle',
                        'type': 'address',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'clientBetData',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'bettorSignature',
                        'type': 'bytes',
                    },
                    {
                        'internalType': 'bytes',
                        'name': 'oracleSignature',
                        'type': 'bytes',
                    },
                ],
                'internalType': 'struct IOrder.OrderData',
                'name': 'order',
                'type': 'tuple',
            },
        ],
        'name': 'getOrderBetsAmounts',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'totalAmount',
                'type': 'uint128',
            },
            {
                'internalType': 'uint128[]',
                'name': 'amounts',
                'type': 'uint128[]',
            },
        ],
        'stateMutability': 'pure',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'lp_',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'payMaster_',
                'type': 'address',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'lp',
        'outputs': [
            {
                'internalType': 'contract ILP',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'payMaster',
        'outputs': [
            {
                'internalType': 'contract IPayMaster',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'renounceOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
];var vaultAbi = [
    {
        'inputs': [],
        'name': 'DepositDoesNotExist',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'ERC721EnumerableForbiddenBatchMint',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'sender',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'ERC721IncorrectOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'ERC721InsufficientApproval',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'approver',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidApprover',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidOperator',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'receiver',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidReceiver',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'sender',
                'type': 'address',
            },
        ],
        'name': 'ERC721InvalidSender',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'ERC721NonexistentToken',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'index',
                'type': 'uint256',
            },
        ],
        'name': 'ERC721OutOfBoundsIndex',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectAmount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectDeposit',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectLeaf',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'IncorrectPercent',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InsufficientTopNodeAmount',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'InvalidInitialization',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'LeafNotExist',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'LeafNumberRangeExceeded',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'LiquidityIsLocked',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NotEnoughLiquidity',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NotEnoughLockedLiquidity',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'NotInitializing',
        'type': 'error',
    },
    {
        'inputs': [],
        'name': 'OnlyAdmin',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'OwnableInvalidOwner',
        'type': 'error',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'account',
                'type': 'address',
            },
        ],
        'name': 'OwnableUnauthorizedAccount',
        'type': 'error',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'newAdmin',
                'type': 'address',
            },
        ],
        'name': 'AdminChanged',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'approved',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'Approval',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'bool',
                'name': 'approved',
                'type': 'bool',
            },
        ],
        'name': 'ApprovalForAll',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'uint64',
                'name': 'version',
                'type': 'uint64',
            },
        ],
        'name': 'Initialized',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'previousOwner',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'OwnershipTransferred',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'indexed': true,
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'Transfer',
        'type': 'event',
    },
    {
        'anonymous': false,
        'inputs': [
            {
                'indexed': false,
                'internalType': 'address',
                'name': 'wallet',
                'type': 'address',
            },
            {
                'indexed': false,
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'name': 'Withdrawn',
        'type': 'event',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'depositor',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'name': 'addDeposit',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'name': 'addLiquidity',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'admin',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'approve',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
        ],
        'name': 'balanceOf',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newAdmin',
                'type': 'address',
            },
        ],
        'name': 'changeAdmin',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'getApproved',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'getLastDepositId',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'getReserve',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'reserve',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'token_',
                'type': 'address',
            },
        ],
        'name': 'initialize',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
        ],
        'name': 'isApprovedForAll',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'depositId',
                'type': 'uint256',
            },
        ],
        'name': 'isDepositExists',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'name': 'lockLiquidity',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'lockedLiquidity',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': '',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'name',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'nextNode',
        'outputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint48',
                'name': 'leaf',
                'type': 'uint48',
            },
        ],
        'name': 'nodeWithdrawView',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'withdrawAmount',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'owner',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'ownerOf',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'renounceOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'safeTransferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
            {
                'internalType': 'bytes',
                'name': 'data',
                'type': 'bytes',
            },
        ],
        'name': 'safeTransferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'operator',
                'type': 'address',
            },
            {
                'internalType': 'bool',
                'name': 'approved',
                'type': 'bool',
            },
        ],
        'name': 'setApprovalForAll',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'bytes4',
                'name': 'interfaceId',
                'type': 'bytes4',
            },
        ],
        'name': 'supportsInterface',
        'outputs': [
            {
                'internalType': 'bool',
                'name': '',
                'type': 'bool',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'symbol',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'token',
        'outputs': [
            {
                'internalType': 'address',
                'name': '',
                'type': 'address',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'index',
                'type': 'uint256',
            },
        ],
        'name': 'tokenByIndex',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'owner',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'index',
                'type': 'uint256',
            },
        ],
        'name': 'tokenOfOwnerByIndex',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'tokenURI',
        'outputs': [
            {
                'internalType': 'string',
                'name': '',
                'type': 'string',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'totalSupply',
        'outputs': [
            {
                'internalType': 'uint256',
                'name': '',
                'type': 'uint256',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'from',
                'type': 'address',
            },
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint256',
                'name': 'tokenId',
                'type': 'uint256',
            },
        ],
        'name': 'transferFrom',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'newOwner',
                'type': 'address',
            },
        ],
        'name': 'transferOwnership',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint48',
                'name': '',
                'type': 'uint48',
            },
        ],
        'name': 'treeNode',
        'outputs': [
            {
                'internalType': 'uint64',
                'name': 'updateId',
                'type': 'uint64',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
        ],
        'name': 'unlockLiquidity',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [],
        'name': 'updateId',
        'outputs': [
            {
                'internalType': 'uint64',
                'name': '',
                'type': 'uint64',
            },
        ],
        'stateMutability': 'view',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
            {
                'internalType': 'uint40',
                'name': 'percent',
                'type': 'uint40',
            },
        ],
        'name': 'withdrawDeposit',
        'outputs': [
            {
                'internalType': 'uint128',
                'name': 'withdrawnAmount',
                'type': 'uint128',
            },
        ],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
    {
        'inputs': [
            {
                'internalType': 'address',
                'name': 'to',
                'type': 'address',
            },
            {
                'internalType': 'uint128',
                'name': 'amount',
                'type': 'uint128',
            },
            {
                'internalType': 'uint48',
                'name': 'depositId',
                'type': 'uint48',
            },
        ],
        'name': 'withdrawLiquidityFor',
        'outputs': [],
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
];var paymasterAbi = [{ 'inputs': [], 'stateMutability': 'nonpayable', 'type': 'constructor' }, { 'inputs': [], 'name': 'AlreadyPaid', 'type': 'error' }, { 'inputs': [], 'name': 'BetDoesNotExist', 'type': 'error' }, { 'inputs': [], 'name': 'IncorrectRelayer', 'type': 'error' }, { 'inputs': [], 'name': 'InsufficientFeeFund', 'type': 'error' }, { 'inputs': [], 'name': 'InsufficientFreeBetFund', 'type': 'error' }, { 'inputs': [], 'name': 'InvalidInitialization', 'type': 'error' }, { 'inputs': [], 'name': 'LpNotMatch', 'type': 'error' }, { 'inputs': [], 'name': 'NotInitializing', 'type': 'error' }, { 'inputs': [], 'name': 'NothingChanged', 'type': 'error' }, { 'inputs': [{ 'internalType': 'address', 'name': 'owner', 'type': 'address' }], 'name': 'OwnableInvalidOwner', 'type': 'error' }, { 'inputs': [{ 'internalType': 'address', 'name': 'account', 'type': 'address' }], 'name': 'OwnableUnauthorizedAccount', 'type': 'error' }, { 'anonymous': false, 'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'core', 'type': 'address' }, { 'indexed': true, 'internalType': 'address', 'name': 'bettor', 'type': 'address' }, { 'indexed': true, 'internalType': 'uint256', 'name': 'freeBetId', 'type': 'uint256' }, { 'indexed': false, 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256' }], 'name': 'BettorWin', 'type': 'event' }, { 'anonymous': false, 'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'affiliate', 'type': 'address' }, { 'indexed': false, 'internalType': 'uint256', 'name': 'freebetAmount', 'type': 'uint256' }, { 'indexed': false, 'internalType': 'uint256', 'name': 'feeAmount', 'type': 'uint256' }], 'name': 'DepositedFunds', 'type': 'event' }, { 'anonymous': false, 'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'core', 'type': 'address' }, { 'indexed': true, 'internalType': 'address', 'name': 'bettor', 'type': 'address' }, { 'indexed': true, 'internalType': 'uint256', 'name': 'betId', 'type': 'uint256' }, { 'indexed': false, 'internalType': 'uint256', 'name': 'freeBetId', 'type': 'uint256' }, { 'indexed': false, 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256' }], 'name': 'FreeBetReturned', 'type': 'event' }, { 'anonymous': false, 'inputs': [{ 'indexed': false, 'internalType': 'uint64', 'name': 'version', 'type': 'uint64' }], 'name': 'Initialized', 'type': 'event' }, { 'anonymous': false, 'inputs': [{ 'indexed': true, 'internalType': 'uint256', 'name': 'freeBetId', 'type': 'uint256' }, { 'components': [{ 'internalType': 'address', 'name': 'affiliate', 'type': 'address' }, { 'internalType': 'address', 'name': 'owner', 'type': 'address' }, { 'internalType': 'address', 'name': 'core', 'type': 'address' }, { 'internalType': 'uint256', 'name': 'azuroBetId', 'type': 'uint256' }, { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128' }, { 'internalType': 'bool', 'name': 'isReturnableBetAmount', 'type': 'bool' }], 'indexed': false, 'internalType': 'struct IPayMaster.FreeBet', 'name': 'freeBet', 'type': 'tuple' }], 'name': 'NewFreeBet', 'type': 'event' }, { 'anonymous': false, 'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'previousOwner', 'type': 'address' }, { 'indexed': true, 'internalType': 'address', 'name': 'newOwner', 'type': 'address' }], 'name': 'OwnershipTransferred', 'type': 'event' }, { 'anonymous': false, 'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'relayer', 'type': 'address' }], 'name': 'RelayerChanged', 'type': 'event' }, { 'anonymous': false, 'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'relayer', 'type': 'address' }, { 'indexed': true, 'internalType': 'address', 'name': 'affiliate', 'type': 'address' }, { 'indexed': true, 'internalType': 'address', 'name': 'bettor', 'type': 'address' }, { 'indexed': false, 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256' }], 'name': 'RelayerRewarded', 'type': 'event' }, { 'anonymous': false, 'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'affiliate', 'type': 'address' }, { 'indexed': false, 'internalType': 'uint256', 'name': 'freebetAmount', 'type': 'uint256' }, { 'indexed': false, 'internalType': 'uint256', 'name': 'feeAmount', 'type': 'uint256' }], 'name': 'WithdrawnFunds', 'type': 'event' }, { 'inputs': [{ 'internalType': 'address', 'name': 'relayer_', 'type': 'address' }], 'name': 'changeRelayer', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function' }, { 'inputs': [{ 'internalType': 'address', 'name': 'account', 'type': 'address' }, { 'internalType': 'uint256', 'name': 'freeBetAmount', 'type': 'uint256' }, { 'internalType': 'uint256', 'name': 'feeAmount', 'type': 'uint256' }], 'name': 'depositFor', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function' }, { 'inputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }], 'name': 'feeFund', 'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }], 'name': 'freeBets', 'outputs': [{ 'internalType': 'address', 'name': 'affiliate', 'type': 'address' }, { 'internalType': 'address', 'name': 'owner', 'type': 'address' }, { 'internalType': 'address', 'name': 'core', 'type': 'address' }, { 'internalType': 'uint256', 'name': 'azuroBetId', 'type': 'uint256' }, { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128' }, { 'internalType': 'bool', 'name': 'isReturnableBetAmount', 'type': 'bool' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }], 'name': 'freeBetsFund', 'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [{ 'internalType': 'address', 'name': 'lpAddress', 'type': 'address' }], 'name': 'initialize', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function' }, { 'inputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }], 'name': 'isLocked', 'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [], 'name': 'lastUsedFreeBetId', 'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [], 'name': 'lp', 'outputs': [{ 'internalType': 'contract ILP', 'name': '', 'type': 'address' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [], 'name': 'owner', 'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [{ 'internalType': 'address', 'name': 'relayExecutor', 'type': 'address' }, { 'components': [{ 'internalType': 'address', 'name': 'betOwner', 'type': 'address' }, { 'components': [{ 'internalType': 'uint256', 'name': 'gameId', 'type': 'uint256' }, { 'internalType': 'uint256', 'name': 'conditionId', 'type': 'uint256' }, { 'internalType': 'enum IOrder.ConditionKind', 'name': 'conditionKind', 'type': 'uint8' }, { 'internalType': 'uint64[]', 'name': 'odds', 'type': 'uint64[]' }, { 'internalType': 'uint128[]', 'name': 'outcomes', 'type': 'uint128[]' }, { 'internalType': 'uint128', 'name': 'potentialLossLimit', 'type': 'uint128' }, { 'internalType': 'uint8', 'name': 'winningOutcomesCount', 'type': 'uint8' }], 'internalType': 'struct IOrder.ConditionData[]', 'name': 'conditionDatas', 'type': 'tuple[]' }, { 'internalType': 'enum IOrder.BetType', 'name': 'betType', 'type': 'uint8' }, { 'internalType': 'address', 'name': 'oracle', 'type': 'address' }, { 'internalType': 'bytes', 'name': 'clientBetData', 'type': 'bytes' }, { 'internalType': 'bytes', 'name': 'bettorSignature', 'type': 'bytes' }, { 'internalType': 'bytes', 'name': 'oracleSignature', 'type': 'bytes' }], 'internalType': 'struct IOrder.OrderData', 'name': 'order', 'type': 'tuple' }, { 'components': [{ 'internalType': 'string', 'name': 'attention', 'type': 'string' }, { 'internalType': 'address', 'name': 'affiliate', 'type': 'address' }, { 'internalType': 'address', 'name': 'core', 'type': 'address' }, { 'internalType': 'uint256', 'name': 'expiresAt', 'type': 'uint256' }, { 'internalType': 'uint256', 'name': 'chainId', 'type': 'uint256' }, { 'internalType': 'uint256', 'name': 'relayerFeeAmount', 'type': 'uint256' }, { 'internalType': 'bool', 'name': 'isFeeSponsored', 'type': 'bool' }, { 'internalType': 'bool', 'name': 'isBetSponsored', 'type': 'bool' }, { 'internalType': 'bool', 'name': 'isSponsoredBetReturnable', 'type': 'bool' }], 'internalType': 'struct IOrder.ClientData', 'name': 'data', 'type': 'tuple' }, { 'internalType': 'uint128', 'name': 'betAmount', 'type': 'uint128' }, { 'internalType': 'uint128[]', 'name': 'amounts', 'type': 'uint128[]' }, { 'internalType': 'bytes', 'name': 'hashes', 'type': 'bytes' }], 'name': 'pay', 'outputs': [{ 'internalType': 'uint128', 'name': 'amountPaidByBettor', 'type': 'uint128' }, { 'internalType': 'uint256', 'name': 'feePaidByBettor', 'type': 'uint256' }], 'stateMutability': 'nonpayable', 'type': 'function' }, { 'inputs': [], 'name': 'relayer', 'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [], 'name': 'renounceOwnership', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function' }, { 'inputs': [], 'name': 'token', 'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }], 'stateMutability': 'view', 'type': 'function' }, { 'inputs': [{ 'internalType': 'address', 'name': 'newOwner', 'type': 'address' }], 'name': 'transferOwnership', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function' }, { 'inputs': [{ 'internalType': 'uint256', 'name': 'freeBetAmount', 'type': 'uint256' }, { 'internalType': 'uint256', 'name': 'feeAmount', 'type': 'uint256' }], 'name': 'withdraw', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function' }, { 'inputs': [{ 'internalType': 'uint256[]', 'name': 'freeBetIds', 'type': 'uint256[]' }], 'name': 'withdrawPayouts', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function' }];const setupContracts = ({ lp, core, relayer, azuroBet, vault, paymaster, cashout, }) => {
    const contracts = {
        lp: {
            address: lp,
            abi: lpAbi,
        },
        core: {
            address: core,
            abi: coreAbi,
        },
        relayer: {
            address: relayer,
            abi: relayerAbi,
        },
        azuroBet: {
            address: azuroBet,
            abi: azuroBetAbi,
        },
        vault: {
            address: vault,
            abi: vaultAbi,
        },
        paymaster: {
            address: paymaster,
            abi: paymasterAbi,
        },
    };
    if (cashout) {
        contracts.cashout = {
            address: cashout,
            abi: cashoutAbi,
        };
    }
    return contracts;
};const endpointNameByChainId = {
    [gnosis.id]: 'gnosis',
    [polygon.id]: 'polygon',
    [polygonAmoy.id]: 'polygon-amoy-dev',
    [chiliz.id]: 'chiliz',
    [spicy.id]: 'chiliz-spicy-dev',
    [base.id]: 'base',
    [baseSepolia.id]: 'base-sepolia-dev',
};
// if (isDevEnabled) {
//   endpointNameByChainId[gnosis.id] = 'gnosis-dev'
//   endpointNameByChainId[polygonAmoy.id] = 'polygon-amoy-dev'
// }
const isDevChain = (chainId) => {
    return (chainId === polygonAmoy.id ||
        chainId === spicy.id ||
        chainId === baseSepolia.id);
};
const getFeedGraphqlEndpoint = (chainId) => (`https://thegraph-1.onchainfeed.org/subgraphs/name/azuro-protocol/azuro-data-feed-${endpointNameByChainId[chainId]}`);
const getBetsGraphqlEndpoint = (chainId) => (`https://thegraph.onchainfeed.org/subgraphs/name/azuro-protocol/azuro-api-${endpointNameByChainId[chainId]}-v3`);
/**
 * @deprecated Only for v2 feed
 */
const getLegacyLiveGraphqlEndpoint = (chainId) => {
    if (isDevChain(chainId)) {
        return 'https://thegraph.azuro.org/subgraphs/name/azuro-protocol/azuro-api-live-data-feed-dev';
    }
    // if (chainId === polygonAmoy.id) {
    //   return 'https://thegraph.azuro.org/subgraphs/name/azuro-protocol/azuro-api-live-data-feed-preprod'
    // }
    return 'https://thegraph.azuro.org/subgraphs/name/azuro-protocol/azuro-api-live-data-feed';
};
const getSocketEndpoint = (chainId) => {
    if (isDevChain(chainId)) {
        return 'wss://dev-streams.onchainfeed.org/v1/streams';
    }
    // if (chainId === polygonAmoy.id) {
    //   return 'wss://preprod-streams.azuro.org/v1/streams'
    // }
    return 'wss://streams.onchainfeed.org/v1/streams';
};
const getApiEndpoint = (chainId) => {
    if (isDevChain(chainId)) {
        return 'https://dev-api.onchainfeed.org/api/v1/public';
    }
    // if (chainId === polygonAmoy.id) {
    //   return 'https://preprod-api.azuro.org/api/v1/public'
    // }
    return 'https://api.onchainfeed.org/api/v1/public';
};const ODDS_DECIMALS = 12;
const CLIENT_DATA_TYPES = [
    { name: 'attention', type: 'string' },
    { name: 'affiliate', type: 'address' },
    { name: 'core', type: 'address' },
    { name: 'expiresAt', type: 'uint256' },
    { name: 'chainId', type: 'uint256' },
    { name: 'relayerFeeAmount', type: 'uint256' },
    { name: 'isFeeSponsored', type: 'bool' },
    { name: 'isBetSponsored', type: 'bool' },
    { name: 'isSponsoredBetReturnable', type: 'bool' },
];
const BET_DATA_TYPES = {
    ClientBetData: [
        { name: 'clientData', type: 'ClientData' },
        { name: 'bets', type: 'SubBet[]' },
    ],
    ClientData: CLIENT_DATA_TYPES,
    SubBet: [
        { name: 'conditionId', type: 'uint256' },
        { name: 'outcomeId', type: 'uint128' },
        { name: 'minOdds', type: 'uint64' },
        { name: 'amount', type: 'uint128' },
        { name: 'nonce', type: 'uint256' },
    ],
};
const COMBO_BET_DATA_TYPES = {
    ClientComboBetData: [
        { name: 'clientData', type: 'ClientData' },
        { name: 'minOdds', type: 'uint64' },
        { name: 'amount', type: 'uint128' },
        { name: 'nonce', type: 'uint256' },
        { name: 'bets', type: 'ComboPart[]' },
    ],
    ClientData: CLIENT_DATA_TYPES,
    ComboPart: [
        { name: 'conditionId', type: 'uint256' },
        { name: 'outcomeId', type: 'uint128' },
    ],
};
const TYPED_DATA_DOMAIN_NAME = 'Live Betting';
const TYPED_DATA_DOMAIN_VERSION = '1.0.0';
const CASHOUT_DATA_TYPES = {
    CashOutItem: [
        { name: 'betId', type: 'uint256' },
        { name: 'bettingContract', type: 'address' },
        { name: 'minOdds', type: 'uint64' },
    ],
    CashOutOrder: [
        { name: 'attention', type: 'string' },
        { name: 'chainId', type: 'uint256' },
        { name: 'items', type: 'CashOutItem[]' },
        { name: 'expiresAt', type: 'uint64' },
    ],
};
const CASHOUT_TYPED_DATA_DOMAIN_NAME = 'Cash Out';
const CASHOUT_TYPED_DATA_DOMAIN_VERSION = '1.0.0';
const gnosisData = {
    chain: gnosis,
    graphql: {
        bets: getBetsGraphqlEndpoint(gnosis.id),
        feed: getFeedGraphqlEndpoint(gnosis.id),
        legacyLive: getLegacyLiveGraphqlEndpoint(gnosis.id),
    },
    socket: getSocketEndpoint(gnosis.id),
    api: getApiEndpoint(gnosis.id),
    environment: environments[gnosis.id],
    contracts: setupContracts({
        lp: '0xeb7cDA87D00d677A6Dc73EB569723b0fA51D97E7',
        core: '0x0e00E6ffcb5E207B800eec9e02999D1Fd9e448f2',
        relayer: '0x40eb85018fA18dDd10a433C8c40ca8D6744d8B32',
        azuroBet: '0xd7cd9342A14962C2dCB14569CB6fcA2759999089',
        vault: '0x14564e6BbbB8DE2f959af8c0e158D334F05393Bb',
        paymaster: '0x3Ebf1a2005f1a87862d61022a5BAC661994dD94e',
        cashout: '0x25de227af58188e656524d1C32cCf7C078cdC891',
    }),
    betToken: {
        address: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
        symbol: 'WXDAI',
        decimals: 18,
    },
};
const gnosisDevData = {
    chain: gnosis,
    graphql: {
        bets: getBetsGraphqlEndpoint(gnosis.id),
        feed: getFeedGraphqlEndpoint(gnosis.id),
        legacyLive: getLegacyLiveGraphqlEndpoint(gnosis.id),
    },
    socket: getSocketEndpoint(gnosis.id),
    api: getApiEndpoint(gnosis.id),
    environment: environments[gnosis.id],
    contracts: setupContracts({
        lp: '0x0C2F50DCE97a4e327f5580bA4aad4E48d27f6DbD',
        core: '0x12d5E6d2e9c47015C26a7c959a5Db42E3eF5a1Ef',
        relayer: '0x7C9C7B37C93EbC2103061834eb2781809f604eAf',
        azuroBet: '0x9407B57bF56292b0d9940Ed69D9a74ACffb11413',
        vault: '0xf4cFe9e703fe24E4Bc4c6dc6678e33Bf08d1F629',
        paymaster: '0x943dD83042572226eFc485AD7Ecc605DFF7D2172',
        cashout: '0xF8E7F2e4693DBEd186b302474EeE5AE4Ab2E0150',
    }),
    betToken: {
        address: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
        symbol: 'WXDAI',
        decimals: 18,
    },
};
const polygonData = {
    chain: polygon,
    graphql: {
        bets: getBetsGraphqlEndpoint(polygon.id),
        feed: getFeedGraphqlEndpoint(polygon.id),
        legacyLive: getLegacyLiveGraphqlEndpoint(polygon.id),
    },
    socket: getSocketEndpoint(polygon.id),
    api: getApiEndpoint(polygon.id),
    environment: environments[polygon.id],
    contracts: setupContracts({
        lp: '0x0FA7FB5407eA971694652E6E16C12A52625DE1b8',
        core: '0xF9548Be470A4e130c90ceA8b179FCD66D2972AC7',
        relayer: '0x8dA05c0021e6b35865FDC959c54dCeF3A4AbBa9d',
        azuroBet: '0x7A1c3FEf712753374C4DCe34254B96faF2B7265B',
        vault: '0x1a0612FE7D0Def35559a1f71Ff155e344Ae69d2C',
        paymaster: '0xeD5760fC2d2f6d363d73e576173e5e8Ca6A877e1',
        cashout: '0x4a2BB4211cCF9b9eA6eF01D0a61448154ED19095',
    }),
    betToken: {
        address: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        symbol: 'USDT',
        decimals: 6,
    },
};
// const polygonAmoyData: ChainData = {
//   chain: polygonAmoy,
//   graphql: {
//     bets: getBetsGraphqlEndpoint(polygonAmoy.id),
//     feed: getFeedGraphqlEndpoint(polygonAmoy.id),
//     legacyLive: getLegacyLiveGraphqlEndpoint(polygonAmoy.id),
//   },
//   socket: getSocketEndpoint(polygonAmoy.id),
//   api: getApiEndpoint(polygonAmoy.id),
//   environment: environments[polygonAmoy.id],
//   contracts: setupContracts({
//     lp: '0x3528186476FD0eA0AdC9fCcc41de4CD138f99653',
//     core: '0x2477B960080B3439b4684df3D9CE53B2ACe64315',
//     relayer: '0x355B8493380fA5D57E4d3aFBF7C5f38b64AD5eA9',
//     azuroBet: '0x5E59ee1b09Cb2Cf031e4Beaa8dB48D4B8b7e38AD',
//     cashout: '0x080d71059891Fb4d722855df28bFB208335F1587',
//   }),
//   betToken: {
//     address: '0xf028b2dd00e20a8d9db3964a5feb0633d2ee46cd',
//     symbol: 'AZUSD',
//     decimals: 6,
//   },
// }
const polygonAmoyData = {
    chain: polygonAmoy,
    graphql: {
        bets: getBetsGraphqlEndpoint(polygonAmoy.id),
        feed: getFeedGraphqlEndpoint(polygonAmoy.id),
        legacyLive: getLegacyLiveGraphqlEndpoint(polygonAmoy.id),
    },
    socket: getSocketEndpoint(polygonAmoy.id),
    api: getApiEndpoint(polygonAmoy.id),
    environment: environments[polygonAmoy.id],
    contracts: setupContracts({
        lp: '0x0a75395Ff15d9557424b632cEBCac448D66F9779',
        core: '0xCD0Db5ef28C3Bd3a69283372dE923Eb4DA0585F6',
        relayer: '0x48c9bE88706F22838070eE7C4bC74Ad7A8eeF114',
        azuroBet: '0x4B75c071dFA5d537979E8b0615Bb97B6337dbFef',
        vault: '0x1Ed6CEEDf7033461a189FD7c3381C34846D7b25a',
        paymaster: '0x2d155962b708c931Fc695F674B415065E78D9F04',
        cashout: '0x7dF132Ad2334a667A004049a75a4a8a530dc24F2',
    }),
    betToken: {
        address: '0xCf1b86ceD971b88C042C64A9c099377e2738073C',
        symbol: 'USDT',
        decimals: 6,
    },
};
const chilizData = {
    chain: chiliz,
    graphql: {
        bets: getBetsGraphqlEndpoint(chiliz.id),
        feed: getFeedGraphqlEndpoint(chiliz.id),
        legacyLive: getLegacyLiveGraphqlEndpoint(chiliz.id),
    },
    socket: getSocketEndpoint(chiliz.id),
    api: getApiEndpoint(chiliz.id),
    environment: environments[chiliz.id],
    contracts: setupContracts({
        lp: '0xEf6b12580301b04CD2551182C88623524B6e47b8',
        core: '0xa5061617Ee6565CF48d7f0FEF06910b9fb9dE2b0',
        relayer: '0x81F72B93ABaf061535aaF5D831F05e0CC4084b32',
        azuroBet: '0x3777B4F27F4B36f14454dbB1f79278bcba694B52',
        vault: '0x32696E01c979E3F542EC49D95729f011eF8F3c28',
        paymaster: '0xB3AE923721e8f3345654eFffC09f6F52afC21F4c',
        cashout: '0x3995eebB51793Ee353162E7400DB455B17dE3692',
    }),
    betToken: {
        address: '0x677F7e16C7Dd57be1D4C8aD1244883214953DC47',
        symbol: 'WCHZ',
        decimals: 18,
    },
};
const spicyData = {
    chain: spicy,
    graphql: {
        bets: getBetsGraphqlEndpoint(spicy.id),
        feed: getFeedGraphqlEndpoint(spicy.id),
        legacyLive: getLegacyLiveGraphqlEndpoint(spicy.id),
    },
    socket: getSocketEndpoint(spicy.id),
    api: getApiEndpoint(spicy.id),
    environment: environments[spicy.id],
    contracts: setupContracts({
        lp: '0x431A0993d29eEb0fF7e3FE351A303eF72195431a',
        core: '0x524994dcA5EA2bc979ac5506E7195F28B4c16932',
        relayer: '0x725ec0A9eC9dC993A86d0eFD7fD78929d226AbE7',
        azuroBet: '0xF7815889e5d0635A31eca34390b25d8D2cEeD902',
        vault: '0x2d76265b15081581F7ccD116828F35dA654f0a79',
        paymaster: '0x3df16FB8Dc28F63565AF2815E04a3368360FFd23',
        cashout: '0x7c771a200EcD61A01af992360303f7b1465Cd8e3',
    }),
    betToken: {
        address: '0x721EF6871f1c4Efe730Dce047D40D1743B886946',
        symbol: 'WCHZ',
        decimals: 18,
    },
};
const baseSepoliaData = {
    chain: baseSepolia,
    graphql: {
        bets: getBetsGraphqlEndpoint(baseSepolia.id),
        feed: getFeedGraphqlEndpoint(baseSepolia.id),
        legacyLive: getLegacyLiveGraphqlEndpoint(baseSepolia.id),
    },
    socket: getSocketEndpoint(baseSepolia.id),
    api: getApiEndpoint(baseSepolia.id),
    environment: environments[baseSepolia.id],
    contracts: setupContracts({
        lp: '0x4fE86EddCC22dc992b7994878169201Ec7ea50AB',
        core: '0x679CC42F69F98631668348d088086359D4217Ffa',
        relayer: '0x2De54cABa6A8198D9Dc51931485Bfdc8017aB0c5',
        azuroBet: '0xD031C4BDd4b7c30e3725132109786B8E158A4c07',
        vault: '0x6910dE58f350CE0A8b42D27004313346A31b3540',
        paymaster: '0xC2577cdcF684C9756f2C81efdA001CbEFEf3Dd92',
        cashout: '0xf52Eb6ec19d81Ea623A7d7Ad397287C0C40f2F37',
    }),
    betToken: {
        address: '0x9e09f213Ff75e53D52e9e777A6567A68683E935f',
        symbol: 'WETH',
        decimals: 18,
    },
};
const baseData = {
    chain: base,
    graphql: {
        bets: getBetsGraphqlEndpoint(base.id),
        feed: getFeedGraphqlEndpoint(base.id),
        legacyLive: getLegacyLiveGraphqlEndpoint(base.id),
    },
    socket: getSocketEndpoint(base.id),
    api: getApiEndpoint(base.id),
    environment: environments[base.id],
    contracts: setupContracts({
        lp: '0x1eD7368bc515E928A4007cEa61FB8a6F8863Af87',
        core: '0xF40cF1dD7d16C098cff5F8B5650A8FaEf1F4640d',
        relayer: '0xD2D508d66dB4fCE4B384e4C3EA2fa53BA43e73b5',
        azuroBet: '0xF328404Dbc8c997d12dC55a1A179AF7F8cb7df90',
        vault: '0xbA390F464395fC0940c0B9591847ad4E836C7A0c',
        paymaster: '0x4a2BB4211cCF9b9eA6eF01D0a61448154ED19095',
        cashout: '0x6EDff24761F4473611B45BDAe4a779ff31af14Be',
    }),
    betToken: {
        address: '0x4200000000000000000000000000000000000006',
        symbol: 'WETH',
        decimals: 18,
    },
};
const chainsData = {
    [gnosis.id]: gnosisData,
    [polygon.id]: polygonData,
    [polygonAmoy.id]: polygonAmoyData,
    [chiliz.id]: chilizData,
    [spicy.id]: spicyData,
    [base.id]: baseData,
    [baseSepolia.id]: baseSepoliaData,
};
// if (isDevEnabled) {
//   chainsData[gnosis.id] = gnosisDevData
//   chainsData[polygonAmoy.id] = polygonAmoyDevData
// }
const chainsDataByEnv = {
    [Environment.GnosisXDAI]: gnosisData,
    [Environment.GnosisDevXDAI]: gnosisDevData,
    [Environment.PolygonUSDT]: polygonData,
    // [Environment.PolygonAmoyAZUSD]: polygonAmoyData,
    [Environment.PolygonAmoyUSDT]: polygonAmoyData,
    [Environment.ChilizWCHZ]: chilizData,
    [Environment.ChilizSpicyWCHZ]: spicyData,
    [Environment.BaseWETH]: baseData,
    [Environment.BaseSepoliaWETH]: baseSepoliaData,
};var BetState;
(function (BetState) {
    BetState["Created"] = "Created";
    BetState["Pending"] = "Pending";
    BetState["Sent"] = "Sent";
    BetState["Accepted"] = "Accepted";
    BetState["Rejected"] = "Rejected";
})(BetState || (BetState = {}));
var BonusType;
(function (BonusType) {
    BonusType["FreeBet"] = "FreeBet";
})(BonusType || (BonusType = {}));
var BonusStatus;
(function (BonusStatus) {
    BonusStatus["Used"] = "Used";
    BonusStatus["Available"] = "Available";
})(BonusStatus || (BonusStatus = {}));
var FreebetType;
(function (FreebetType) {
    FreebetType["OnlyWin"] = "OnlyWin";
    FreebetType["AllWin"] = "AllWin";
})(FreebetType || (FreebetType = {}));
var BetRestrictionType;
(function (BetRestrictionType) {
    BetRestrictionType["Ordinar"] = "Ordinar";
    BetRestrictionType["Combo"] = "Combo";
})(BetRestrictionType || (BetRestrictionType = {}));
var EventRestrictionState;
(function (EventRestrictionState) {
    EventRestrictionState["Live"] = "Live";
    EventRestrictionState["Prematch"] = "Prematch";
})(EventRestrictionState || (EventRestrictionState = {}));const BettorFragmentDoc = gql `
    fragment Bettor on Bettor {
  id
  rawToPayout
  rawInBets
  rawTotalPayout
  rawTotalProfit
  betsCount
  wonBetsCount
  lostBetsCount
}
    `;const LegacyLiveBetFragmentDoc = gql `
    fragment LegacyLiveBet on LiveBet {
  id
  tokenId: betId
  actor
  amount
  status
  potentialPayout
  payout
  result
  odds
  settledOdds
  createdAt: createdBlockTimestamp
  resolvedAt: resolvedBlockTimestamp
  txHash: createdTxHash
  redeemedTxHash
  affiliate
  isRedeemed
  isRedeemable
  isCashedOut
  core {
    address
    liquidityPool {
      address
    }
  }
  selections {
    odds
    result
    outcome {
      outcomeId
      condition {
        conditionId
        status
        gameId
        wonOutcomeIds
      }
    }
  }
  cashout {
    payout
  }
}
    `;const LegacyPrematchBetFragmentDoc = gql `
    fragment LegacyPrematchBet on Bet {
  id
  tokenId: betId
  actor
  amount
  status
  potentialPayout
  payout
  result
  odds
  settledOdds
  createdAt: createdBlockTimestamp
  resolvedAt: resolvedBlockTimestamp
  txHash: createdTxHash
  redeemedTxHash
  affiliate
  isRedeemed
  isRedeemable
  isCashedOut
  core {
    address
    liquidityPool {
      address
    }
  }
  selections {
    odds
    result
    outcome {
      outcomeId
      title
      condition {
        conditionId
        status
        title
        wonOutcomeIds
        game {
          id
          gameId
          title
          startsAt
          status
          slug
          sport {
            sportId
            slug
            name
            sporthub {
              id
              slug
            }
          }
          league {
            id
            slug
            name
            country {
              id
              slug
              name
            }
          }
          participants {
            image
            name
          }
        }
      }
    }
  }
  freebet {
    freebetId
    contractAddress: freebetContractAddress
  }
  cashout {
    payout
  }
}
    `;const BetFragmentDoc = gql `
    fragment Bet on V3_Bet {
  id
  tokenId: betId
  actor
  amount
  status
  potentialPayout
  payout
  result
  odds
  settledOdds
  createdAt: createdBlockTimestamp
  resolvedAt: resolvedBlockTimestamp
  txHash: createdTxHash
  redeemedTxHash
  affiliate
  isRedeemed
  isRedeemable
  isCashedOut
  core {
    address
    liquidityPool {
      address
    }
  }
  selections {
    odds
    result
    conditionKind
    outcome {
      outcomeId
      title
      condition {
        conditionId
        title
        status
        gameId
        wonOutcomeIds
      }
    }
  }
  freebetId
  isFreebetAmountReturnable
  paymasterContractAddress
  cashout {
    payout
  }
}
    `;const BettorsDocument = gql `
    query Bettors($where: Bettor_filter!) {
  bettors(where: $where, subgraphError: allow) {
    ...Bettor
  }
}
    ${BettorFragmentDoc}`;const LegacyBetsDocument = gql `
    query LegacyBets($first: Int, $skip: Int, $where: Bet_filter!, $orderBy: Bet_orderBy, $orderDirection: OrderDirection) {
  bets(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    ...LegacyPrematchBet
  }
  liveBets(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    ...LegacyLiveBet
  }
}
    ${LegacyPrematchBetFragmentDoc}
${LegacyLiveBetFragmentDoc}`;const GameBetsDocument = gql `
    query GameBets($gameId: BigInt!, $actor: String) {
  bets(where: {_games_: {gameId: $gameId}, actor: $actor}) {
    rawAmount
    rawPotentialPayout
    result
    status
    isCashedOut
    selections {
      rawOdds
      outcome {
        outcomeId
        condition {
          conditionId
          game {
            gameId
          }
        }
      }
    }
    freebet {
      id
    }
  }
  liveBets(where: {_gamesIds: [$gameId], actor: $actor}) {
    rawAmount
    rawPotentialPayout
    result
    status
    isCashedOut
    selections {
      outcome {
        outcomeId
        condition {
          conditionId
        }
      }
    }
  }
  v3Bets(where: {_gamesIds_contains: [$gameId], actor: $actor}) {
    rawAmount
    rawPotentialPayout
    result
    status
    isCashedOut
    selections {
      rawOdds
      outcome {
        outcomeId
        condition {
          conditionId
          gameId
        }
      }
    }
    freebet {
      id
    }
  }
}
    `;const BetsDocument = gql `
    query Bets($first: Int, $skip: Int, $where: V3_Bet_filter!, $orderBy: V3_Bet_orderBy, $orderDirection: OrderDirection) {
  v3Bets(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    ...Bet
  }
}
    ${BetFragmentDoc}`;const ConditionFragmentDoc = gql `
    fragment Condition on Condition {
  id
  conditionId
  state
  title
  isExpressForbidden
  isPrematchEnabled
  isLiveEnabled
  margin
  outcomes {
    title
    outcomeId
    odds: currentOdds
  }
  game {
    gameId
    sport {
      sportId
    }
  }
}
    `;const GameInfoFragmentDoc = gql `
    fragment GameInfo on Game {
  id
  gameId
  slug
  title
  startsAt
  state
  turnover
  sport {
    sportId
    slug
    name
    sporthub {
      id
      slug
    }
  }
  league {
    id
    slug
    name
  }
  country {
    id
    slug
    name
  }
  participants {
    image
    name
  }
}
    `;const ConditionDocument = gql `
    query Condition($id: ID!) {
  condition(id: $id, subgraphError: allow) {
    ...Condition
  }
}
    ${ConditionFragmentDoc}`;const ConditionsDocument = gql `
    query Conditions($where: Condition_filter!, $orderBy: Condition_orderBy, $orderDirection: OrderDirection) {
  conditions(
    where: $where
    first: 1000
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    ...Condition
    wonOutcomeIds
  }
}
    ${ConditionFragmentDoc}`;const ConditionsBatchDocument = gql `
    query ConditionsBatch($conditionFilter: Condition_filter) {
  conditions(where: $conditionFilter, first: 1000, subgraphError: allow) {
    state
    conditionId
    outcomes {
      id
      outcomeId
      odds: currentOdds
    }
  }
}
    `;const GameDocument = gql `
    query Game($id: ID!) {
  game(id: $id, subgraphError: allow) {
    ...GameInfo
  }
}
    ${GameInfoFragmentDoc}`;const GamesDocument = gql `
    query Games($first: Int, $skip: Int, $where: Game_filter!, $orderBy: Game_orderBy, $orderDirection: OrderDirection) {
  games(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    ...GameInfo
  }
}
    ${GameInfoFragmentDoc}`;const NavigationDocument = gql `
    query Navigation($sportFilter: Sport_filter, $countryFilter: Country_filter, $leagueFilter: League_filter) {
  sports(where: $sportFilter, subgraphError: allow) {
    id
    slug
    name
    sportId
    sporthub {
      id
      slug
    }
    activeGamesCount
    activeLiveGamesCount
    activePrematchGamesCount
    countries(where: $countryFilter) {
      id
      slug
      name
      turnover
      activeGamesCount
      activeLiveGamesCount
      activePrematchGamesCount
      leagues(where: $leagueFilter) {
        id
        slug
        name
        turnover
        activeGamesCount
        activeLiveGamesCount
        activePrematchGamesCount
      }
    }
  }
}
    `;const SportsDocument = gql `
    query Sports($first: Int, $sportFilter: Sport_filter, $countryFilter: Country_filter, $leagueFilter: League_filter, $gameFilter: Game_filter, $gameOrderBy: Game_orderBy, $gameOrderDirection: OrderDirection) {
  sports(
    where: $sportFilter
    orderBy: turnover
    orderDirection: desc
    subgraphError: allow
  ) {
    id
    slug
    name
    sportId
    turnover
    countries(where: $countryFilter, orderBy: turnover, orderDirection: desc) {
      slug
      name
      turnover
      leagues(where: $leagueFilter, orderBy: turnover, orderDirection: desc) {
        slug
        name
        turnover
        games(
          where: $gameFilter
          first: $first
          orderBy: $gameOrderBy
          orderDirection: $gameOrderDirection
        ) {
          ...GameInfo
        }
      }
    }
  }
}
    ${GameInfoFragmentDoc}`;const SportsNavigationDocument = gql `
    query SportsNavigation($sportFilter: Sport_filter) {
  sports(where: $sportFilter, subgraphError: allow) {
    id
    slug
    name
    sportId
    sporthub {
      id
      slug
    }
    activeGamesCount
    activeLiveGamesCount
    activePrematchGamesCount
  }
}
    `;const LegacyLiveGamesDocument = gql `
    query LegacyLiveGames($first: Int, $skip: Int, $where: Game_filter!, $orderBy: Game_orderBy, $orderDirection: OrderDirection) {
  games(
    first: $first
    skip: $skip
    where: $where
    orderBy: $orderBy
    orderDirection: $orderDirection
    subgraphError: allow
  ) {
    id
    gameId
    slug
    title
    startsAt
    status
    sport {
      sportId
      slug
      name
      sporthub {
        id
        slug
      }
    }
    league {
      id
      slug
      name
      country {
        id
        slug
        name
      }
    }
    participants {
      image
      name
    }
  }
}
    `;var AffiliateMonthly_OrderBy;
(function (AffiliateMonthly_OrderBy) {
    AffiliateMonthly_OrderBy["Affiliate"] = "affiliate";
    AffiliateMonthly_OrderBy["BetsCount"] = "betsCount";
    AffiliateMonthly_OrderBy["Id"] = "id";
    AffiliateMonthly_OrderBy["LastAnyBetCreatedTimestamp"] = "lastAnyBetCreatedTimestamp";
    AffiliateMonthly_OrderBy["Month"] = "month";
    AffiliateMonthly_OrderBy["Year"] = "year";
})(AffiliateMonthly_OrderBy || (AffiliateMonthly_OrderBy = {}));
var Aggregation_Interval$1;
(function (Aggregation_Interval) {
    Aggregation_Interval["Day"] = "day";
    Aggregation_Interval["Hour"] = "hour";
})(Aggregation_Interval$1 || (Aggregation_Interval$1 = {}));
var AzuroBetContract_OrderBy;
(function (AzuroBetContract_OrderBy) {
    AzuroBetContract_OrderBy["Address"] = "address";
    AzuroBetContract_OrderBy["Core"] = "core";
    AzuroBetContract_OrderBy["Id"] = "id";
})(AzuroBetContract_OrderBy || (AzuroBetContract_OrderBy = {}));
var BetMargin_OrderBy;
(function (BetMargin_OrderBy) {
    BetMargin_OrderBy["Id"] = "id";
    BetMargin_OrderBy["Margins"] = "margins";
})(BetMargin_OrderBy || (BetMargin_OrderBy = {}));
var BetResult;
(function (BetResult) {
    BetResult["Lost"] = "Lost";
    BetResult["Won"] = "Won";
})(BetResult || (BetResult = {}));
var BetStatus$1;
(function (BetStatus) {
    BetStatus["Accepted"] = "Accepted";
    BetStatus["Canceled"] = "Canceled";
    BetStatus["Resolved"] = "Resolved";
})(BetStatus$1 || (BetStatus$1 = {}));
var BetType;
(function (BetType) {
    BetType["Express"] = "Express";
    BetType["Ordinar"] = "Ordinar";
})(BetType || (BetType = {}));
var Bet_OrderBy;
(function (Bet_OrderBy) {
    Bet_OrderBy["CanceledSubBetsCount"] = "_canceledSubBetsCount";
    Bet_OrderBy["ConditionIds"] = "_conditionIds";
    Bet_OrderBy["Conditions"] = "_conditions";
    Bet_OrderBy["Games"] = "_games";
    Bet_OrderBy["IsFreebet"] = "_isFreebet";
    Bet_OrderBy["LostSubBetsCount"] = "_lostSubBetsCount";
    Bet_OrderBy["MarginsForSettle"] = "_marginsForSettle";
    Bet_OrderBy["OddsDecimals"] = "_oddsDecimals";
    Bet_OrderBy["SubBetsCount"] = "_subBetsCount";
    Bet_OrderBy["TokenDecimals"] = "_tokenDecimals";
    Bet_OrderBy["UpdatedAt"] = "_updatedAt";
    Bet_OrderBy["WonSubBetsCount"] = "_wonSubBetsCount";
    Bet_OrderBy["Actor"] = "actor";
    Bet_OrderBy["Affiliate"] = "affiliate";
    Bet_OrderBy["Amount"] = "amount";
    Bet_OrderBy["ApproxSettledAt"] = "approxSettledAt";
    Bet_OrderBy["BetId"] = "betId";
    Bet_OrderBy["Bettor"] = "bettor";
    Bet_OrderBy["Cashout"] = "cashout";
    Bet_OrderBy["Core"] = "core";
    Bet_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Bet_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Bet_OrderBy["CreatedTxHash"] = "createdTxHash";
    Bet_OrderBy["Freebet"] = "freebet";
    Bet_OrderBy["Id"] = "id";
    Bet_OrderBy["IsCashedOut"] = "isCashedOut";
    Bet_OrderBy["IsRedeemable"] = "isRedeemable";
    Bet_OrderBy["IsRedeemed"] = "isRedeemed";
    Bet_OrderBy["Odds"] = "odds";
    Bet_OrderBy["Owner"] = "owner";
    Bet_OrderBy["Payout"] = "payout";
    Bet_OrderBy["PotentialPayout"] = "potentialPayout";
    Bet_OrderBy["RawAmount"] = "rawAmount";
    Bet_OrderBy["RawOdds"] = "rawOdds";
    Bet_OrderBy["RawPayout"] = "rawPayout";
    Bet_OrderBy["RawPotentialPayout"] = "rawPotentialPayout";
    Bet_OrderBy["RawSettledMargin"] = "rawSettledMargin";
    Bet_OrderBy["RawSettledOdds"] = "rawSettledOdds";
    Bet_OrderBy["RedeemedBlockNumber"] = "redeemedBlockNumber";
    Bet_OrderBy["RedeemedBlockTimestamp"] = "redeemedBlockTimestamp";
    Bet_OrderBy["RedeemedTxHash"] = "redeemedTxHash";
    Bet_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    Bet_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    Bet_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    Bet_OrderBy["Result"] = "result";
    Bet_OrderBy["Selections"] = "selections";
    Bet_OrderBy["SettledMargin"] = "settledMargin";
    Bet_OrderBy["SettledOdds"] = "settledOdds";
    Bet_OrderBy["Status"] = "status";
    Bet_OrderBy["Type"] = "type";
})(Bet_OrderBy || (Bet_OrderBy = {}));
var Bettor_OrderBy;
(function (Bettor_OrderBy) {
    Bettor_OrderBy["UpdatedAt"] = "_updatedAt";
    Bettor_OrderBy["Address"] = "address";
    Bettor_OrderBy["Affiliate"] = "affiliate";
    Bettor_OrderBy["AvgBetAmount"] = "avgBetAmount";
    Bettor_OrderBy["BetsCount"] = "betsCount";
    Bettor_OrderBy["BiggestBetAmount"] = "biggestBetAmount";
    Bettor_OrderBy["BiggestPayout"] = "biggestPayout";
    Bettor_OrderBy["CanceledBetsCount"] = "canceledBetsCount";
    Bettor_OrderBy["ExpressBetsCount"] = "expressBetsCount";
    Bettor_OrderBy["FirstBetTimestamp"] = "firstBetTimestamp";
    Bettor_OrderBy["Id"] = "id";
    Bettor_OrderBy["InBets"] = "inBets";
    Bettor_OrderBy["LastBetTimestamp"] = "lastBetTimestamp";
    Bettor_OrderBy["LiveBetsCount"] = "liveBetsCount";
    Bettor_OrderBy["LostBetsCount"] = "lostBetsCount";
    Bettor_OrderBy["Pnl"] = "pnl";
    Bettor_OrderBy["PrematchBetsCount"] = "prematchBetsCount";
    Bettor_OrderBy["RawAvgBetAmount"] = "rawAvgBetAmount";
    Bettor_OrderBy["RawBiggestBetAmount"] = "rawBiggestBetAmount";
    Bettor_OrderBy["RawBiggestPayout"] = "rawBiggestPayout";
    Bettor_OrderBy["RawInBets"] = "rawInBets";
    Bettor_OrderBy["RawToPayout"] = "rawToPayout";
    Bettor_OrderBy["RawTotalPayout"] = "rawTotalPayout";
    Bettor_OrderBy["RawTotalProfit"] = "rawTotalProfit";
    Bettor_OrderBy["RawTurnover"] = "rawTurnover";
    Bettor_OrderBy["RedeemedBetsCount"] = "redeemedBetsCount";
    Bettor_OrderBy["RedeemedCanceledBetsCount"] = "redeemedCanceledBetsCount";
    Bettor_OrderBy["RedeemedLostBetsCount"] = "redeemedLostBetsCount";
    Bettor_OrderBy["RedeemedWonBetsCount"] = "redeemedWonBetsCount";
    Bettor_OrderBy["SettledBetsCount"] = "settledBetsCount";
    Bettor_OrderBy["ToPayout"] = "toPayout";
    Bettor_OrderBy["TotalPayout"] = "totalPayout";
    Bettor_OrderBy["TotalProfit"] = "totalProfit";
    Bettor_OrderBy["Turnover"] = "turnover";
    Bettor_OrderBy["V3BetsCount"] = "v3BetsCount";
    Bettor_OrderBy["WonBetsCount"] = "wonBetsCount";
})(Bettor_OrderBy || (Bettor_OrderBy = {}));
var CashbackContract_OrderBy;
(function (CashbackContract_OrderBy) {
    CashbackContract_OrderBy["Address"] = "address";
    CashbackContract_OrderBy["Affiliate"] = "affiliate";
    CashbackContract_OrderBy["Id"] = "id";
    CashbackContract_OrderBy["Manager"] = "manager";
    CashbackContract_OrderBy["Name"] = "name";
})(CashbackContract_OrderBy || (CashbackContract_OrderBy = {}));
var Cashback_OrderBy;
(function (Cashback_OrderBy) {
    Cashback_OrderBy["UpdatedAt"] = "_updatedAt";
    Cashback_OrderBy["Account"] = "account";
    Cashback_OrderBy["Affiliate"] = "affiliate";
    Cashback_OrderBy["Amount"] = "amount";
    Cashback_OrderBy["CashbackContractAddress"] = "cashbackContractAddress";
    Cashback_OrderBy["CashbackId"] = "cashbackId";
    Cashback_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Cashback_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Cashback_OrderBy["CreatedTxHash"] = "createdTxHash";
    Cashback_OrderBy["ExpiresAt"] = "expiresAt";
    Cashback_OrderBy["Id"] = "id";
    Cashback_OrderBy["TokenAddress"] = "tokenAddress";
})(Cashback_OrderBy || (Cashback_OrderBy = {}));
var Cashout_OrderBy;
(function (Cashout_OrderBy) {
    Cashout_OrderBy["OddsDecimals"] = "_oddsDecimals";
    Cashout_OrderBy["TokenDecimals"] = "_tokenDecimals";
    Cashout_OrderBy["UpdatedAt"] = "_updatedAt";
    Cashout_OrderBy["BetContractAddress"] = "betContractAddress";
    Cashout_OrderBy["BetId"] = "betId";
    Cashout_OrderBy["CashoutContractAddress"] = "cashoutContractAddress";
    Cashout_OrderBy["Core"] = "core";
    Cashout_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Cashout_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Cashout_OrderBy["CreatedTxHash"] = "createdTxHash";
    Cashout_OrderBy["Id"] = "id";
    Cashout_OrderBy["Odds"] = "odds";
    Cashout_OrderBy["Owner"] = "owner";
    Cashout_OrderBy["Payout"] = "payout";
    Cashout_OrderBy["RawOdds"] = "rawOdds";
    Cashout_OrderBy["RawPayout"] = "rawPayout";
})(Cashout_OrderBy || (Cashout_OrderBy = {}));
var ConditionLogStatus;
(function (ConditionLogStatus) {
    ConditionLogStatus["Canceled"] = "Canceled";
    ConditionLogStatus["Created"] = "Created";
    ConditionLogStatus["Paused"] = "Paused";
    ConditionLogStatus["Resolved"] = "Resolved";
    ConditionLogStatus["Unpaused"] = "Unpaused";
})(ConditionLogStatus || (ConditionLogStatus = {}));
var ConditionLog_OrderBy;
(function (ConditionLog_OrderBy) {
    ConditionLog_OrderBy["ConditionId"] = "conditionId";
    ConditionLog_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    ConditionLog_OrderBy["Id"] = "id";
    ConditionLog_OrderBy["IsLive"] = "isLive";
    ConditionLog_OrderBy["Status"] = "status";
})(ConditionLog_OrderBy || (ConditionLog_OrderBy = {}));
var ConditionStatus;
(function (ConditionStatus) {
    ConditionStatus["Canceled"] = "Canceled";
    ConditionStatus["Created"] = "Created";
    ConditionStatus["Paused"] = "Paused";
    ConditionStatus["Resolved"] = "Resolved";
})(ConditionStatus || (ConditionStatus = {}));
var Condition_OrderBy$1;
(function (Condition_OrderBy) {
    Condition_OrderBy["OutcomesKey"] = "_outcomesKey";
    Condition_OrderBy["UpdatedAt"] = "_updatedAt";
    Condition_OrderBy["WinningOutcomesCount"] = "_winningOutcomesCount";
    Condition_OrderBy["ConditionId"] = "conditionId";
    Condition_OrderBy["Core"] = "core";
    Condition_OrderBy["CoreAddress"] = "coreAddress";
    Condition_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Condition_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Condition_OrderBy["CreatedTxHash"] = "createdTxHash";
    Condition_OrderBy["Game"] = "game";
    Condition_OrderBy["Hidden"] = "hidden";
    Condition_OrderBy["Id"] = "id";
    Condition_OrderBy["InternalStartsAt"] = "internalStartsAt";
    Condition_OrderBy["IsExpressForbidden"] = "isExpressForbidden";
    Condition_OrderBy["Margin"] = "margin";
    Condition_OrderBy["Outcomes"] = "outcomes";
    Condition_OrderBy["OutcomesIds"] = "outcomesIds";
    Condition_OrderBy["Provider"] = "provider";
    Condition_OrderBy["Reinforcement"] = "reinforcement";
    Condition_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    Condition_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    Condition_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    Condition_OrderBy["Status"] = "status";
    Condition_OrderBy["Title"] = "title";
    Condition_OrderBy["Turnover"] = "turnover";
    Condition_OrderBy["WonOutcomeIds"] = "wonOutcomeIds";
    Condition_OrderBy["WonOutcomes"] = "wonOutcomes";
})(Condition_OrderBy$1 || (Condition_OrderBy$1 = {}));
var CoreContract_OrderBy;
(function (CoreContract_OrderBy) {
    CoreContract_OrderBy["Address"] = "address";
    CoreContract_OrderBy["Id"] = "id";
    CoreContract_OrderBy["LiquidityPool"] = "liquidityPool";
    CoreContract_OrderBy["Type"] = "type";
})(CoreContract_OrderBy || (CoreContract_OrderBy = {}));
var Country_OrderBy$1;
(function (Country_OrderBy) {
    Country_OrderBy["ActiveLeaguesEntityIds"] = "activeLeaguesEntityIds";
    Country_OrderBy["HasActiveLeagues"] = "hasActiveLeagues";
    Country_OrderBy["Id"] = "id";
    Country_OrderBy["Leagues"] = "leagues";
    Country_OrderBy["Name"] = "name";
    Country_OrderBy["Slug"] = "slug";
    Country_OrderBy["Sport"] = "sport";
    Country_OrderBy["Turnover"] = "turnover";
})(Country_OrderBy$1 || (Country_OrderBy$1 = {}));
var EventName$1;
(function (EventName) {
    EventName["AzuroBetTransfer"] = "AzuroBetTransfer";
    EventName["BetCashedOut"] = "BetCashedOut";
    EventName["BetSettled"] = "BetSettled";
    EventName["BettorWin"] = "BettorWin";
    EventName["CashbackWithdrawn"] = "CashbackWithdrawn";
    EventName["ConditionCreated"] = "ConditionCreated";
    EventName["ConditionResolved"] = "ConditionResolved";
    EventName["ConditionShifted"] = "ConditionShifted";
    EventName["ConditionStopped"] = "ConditionStopped";
    EventName["FreeBetBettorWin"] = "FreeBetBettorWin";
    EventName["FreeBetMinted"] = "FreeBetMinted";
    EventName["FreeBetRedeemed"] = "FreeBetRedeemed";
    EventName["FreeBetReissued"] = "FreeBetReissued";
    EventName["FreeBetTransfer"] = "FreeBetTransfer";
    EventName["GameCanceled"] = "GameCanceled";
    EventName["GameShifted"] = "GameShifted";
    EventName["LiquidityAdded"] = "LiquidityAdded";
    EventName["LiquidityRemoved"] = "LiquidityRemoved";
    EventName["LiquidityTransfer"] = "LiquidityTransfer";
    EventName["LiveBetSettled"] = "LiveBetSettled";
    EventName["MarginChanged"] = "MarginChanged";
    EventName["NewBet"] = "NewBet";
    EventName["NewGame"] = "NewGame";
    EventName["NewLiveBet"] = "NewLiveBet";
    EventName["ReinforcementChanged"] = "ReinforcementChanged";
    EventName["V3BetCashedOut"] = "V3_BetCashedOut";
    EventName["V3BetRejected"] = "V3_BetRejected";
    EventName["V3BetSettled"] = "V3_BetSettled";
    EventName["V3BetTransfer"] = "V3_BetTransfer";
    EventName["V3BettorWin"] = "V3_BettorWin";
    EventName["V3ConditionCreated"] = "V3_ConditionCreated";
    EventName["V3ConditionResolved"] = "V3_ConditionResolved";
    EventName["V3FreebetRedeemed"] = "V3_FreebetRedeemed";
    EventName["V3NewBet"] = "V3_NewBet";
})(EventName$1 || (EventName$1 = {}));
var Event_OrderBy$1;
(function (Event_OrderBy) {
    Event_OrderBy["Affiliate"] = "affiliate";
    Event_OrderBy["BetId"] = "betId";
    Event_OrderBy["BlockNumber"] = "blockNumber";
    Event_OrderBy["BlockTimestamp"] = "blockTimestamp";
    Event_OrderBy["CashbackId"] = "cashbackId";
    Event_OrderBy["ConditionId"] = "conditionId";
    Event_OrderBy["ContractAddress"] = "contractAddress";
    Event_OrderBy["DepositId"] = "depositId";
    Event_OrderBy["FreebetId"] = "freebetId";
    Event_OrderBy["GameId"] = "gameId";
    Event_OrderBy["GasPrice"] = "gasPrice";
    Event_OrderBy["GasUsed"] = "gasUsed";
    Event_OrderBy["Id"] = "id";
    Event_OrderBy["LogIndex"] = "logIndex";
    Event_OrderBy["Name"] = "name";
    Event_OrderBy["SortOrder"] = "sortOrder";
    Event_OrderBy["TransactionIndex"] = "transactionIndex";
    Event_OrderBy["TxHash"] = "txHash";
})(Event_OrderBy$1 || (Event_OrderBy$1 = {}));
var ExpressPrematchRelation_OrderBy;
(function (ExpressPrematchRelation_OrderBy) {
    ExpressPrematchRelation_OrderBy["Id"] = "id";
    ExpressPrematchRelation_OrderBy["PrematchAddress"] = "prematchAddress";
})(ExpressPrematchRelation_OrderBy || (ExpressPrematchRelation_OrderBy = {}));
var FreebetContract_OrderBy;
(function (FreebetContract_OrderBy) {
    FreebetContract_OrderBy["Address"] = "address";
    FreebetContract_OrderBy["Affiliate"] = "affiliate";
    FreebetContract_OrderBy["Id"] = "id";
    FreebetContract_OrderBy["LiquidityPool"] = "liquidityPool";
    FreebetContract_OrderBy["Manager"] = "manager";
    FreebetContract_OrderBy["Name"] = "name";
})(FreebetContract_OrderBy || (FreebetContract_OrderBy = {}));
var FreebetStatus;
(function (FreebetStatus) {
    FreebetStatus["Created"] = "Created";
    FreebetStatus["Redeemed"] = "Redeemed";
    FreebetStatus["Reissued"] = "Reissued";
    FreebetStatus["Withdrawn"] = "Withdrawn";
})(FreebetStatus || (FreebetStatus = {}));
var Freebet_OrderBy;
(function (Freebet_OrderBy) {
    Freebet_OrderBy["UpdatedAt"] = "_updatedAt";
    Freebet_OrderBy["Amount"] = "amount";
    Freebet_OrderBy["AzuroBetId"] = "azuroBetId";
    Freebet_OrderBy["Burned"] = "burned";
    Freebet_OrderBy["Core"] = "core";
    Freebet_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Freebet_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Freebet_OrderBy["CreatedTxHash"] = "createdTxHash";
    Freebet_OrderBy["DurationTime"] = "durationTime";
    Freebet_OrderBy["ExpiresAt"] = "expiresAt";
    Freebet_OrderBy["Freebet"] = "freebet";
    Freebet_OrderBy["FreebetContractAddress"] = "freebetContractAddress";
    Freebet_OrderBy["FreebetContractAffiliate"] = "freebetContractAffiliate";
    Freebet_OrderBy["FreebetContractName"] = "freebetContractName";
    Freebet_OrderBy["FreebetId"] = "freebetId";
    Freebet_OrderBy["Id"] = "id";
    Freebet_OrderBy["IsResolved"] = "isResolved";
    Freebet_OrderBy["MinOdds"] = "minOdds";
    Freebet_OrderBy["Owner"] = "owner";
    Freebet_OrderBy["RawAmount"] = "rawAmount";
    Freebet_OrderBy["RawMinOdds"] = "rawMinOdds";
    Freebet_OrderBy["Status"] = "status";
    Freebet_OrderBy["TokenDecimals"] = "tokenDecimals";
})(Freebet_OrderBy || (Freebet_OrderBy = {}));
var GameStatus;
(function (GameStatus) {
    GameStatus["Canceled"] = "Canceled";
    GameStatus["Created"] = "Created";
    GameStatus["Paused"] = "Paused";
    GameStatus["Resolved"] = "Resolved";
})(GameStatus || (GameStatus = {}));
var Game_OrderBy$1;
(function (Game_OrderBy) {
    Game_OrderBy["ActiveConditionsEntityIds"] = "_activeConditionsEntityIds";
    Game_OrderBy["CanceledConditionsEntityIds"] = "_canceledConditionsEntityIds";
    Game_OrderBy["ConditionsCount"] = "_conditionsCount";
    Game_OrderBy["PausedConditionsEntityIds"] = "_pausedConditionsEntityIds";
    Game_OrderBy["ProviderTitle"] = "_providerTitle";
    Game_OrderBy["ResolvedConditionsEntityIds"] = "_resolvedConditionsEntityIds";
    Game_OrderBy["UpdatedAt"] = "_updatedAt";
    Game_OrderBy["Conditions"] = "conditions";
    Game_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Game_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Game_OrderBy["CreatedTxHash"] = "createdTxHash";
    Game_OrderBy["GameId"] = "gameId";
    Game_OrderBy["HasActiveConditions"] = "hasActiveConditions";
    Game_OrderBy["Id"] = "id";
    Game_OrderBy["League"] = "league";
    Game_OrderBy["LiquidityPool"] = "liquidityPool";
    Game_OrderBy["Participants"] = "participants";
    Game_OrderBy["Provider"] = "provider";
    Game_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    Game_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    Game_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    Game_OrderBy["ShiftedBlockNumber"] = "shiftedBlockNumber";
    Game_OrderBy["ShiftedBlockTimestamp"] = "shiftedBlockTimestamp";
    Game_OrderBy["ShiftedTxHash"] = "shiftedTxHash";
    Game_OrderBy["Slug"] = "slug";
    Game_OrderBy["Sport"] = "sport";
    Game_OrderBy["StartsAt"] = "startsAt";
    Game_OrderBy["Status"] = "status";
    Game_OrderBy["Title"] = "title";
    Game_OrderBy["Turnover"] = "turnover";
})(Game_OrderBy$1 || (Game_OrderBy$1 = {}));
var League_OrderBy$1;
(function (League_OrderBy) {
    League_OrderBy["ActiveGamesEntityIds"] = "activeGamesEntityIds";
    League_OrderBy["Country"] = "country";
    League_OrderBy["Games"] = "games";
    League_OrderBy["HasActiveGames"] = "hasActiveGames";
    League_OrderBy["Id"] = "id";
    League_OrderBy["Name"] = "name";
    League_OrderBy["Slug"] = "slug";
    League_OrderBy["Turnover"] = "turnover";
})(League_OrderBy$1 || (League_OrderBy$1 = {}));
var LiquidityPoolContractType;
(function (LiquidityPoolContractType) {
    LiquidityPoolContractType["V1"] = "V1";
    LiquidityPoolContractType["V2"] = "V2";
    LiquidityPoolContractType["V3"] = "V3";
})(LiquidityPoolContractType || (LiquidityPoolContractType = {}));
var LiquidityPoolContract_OrderBy;
(function (LiquidityPoolContract_OrderBy) {
    LiquidityPoolContract_OrderBy["Address"] = "address";
    LiquidityPoolContract_OrderBy["Apr"] = "apr";
    LiquidityPoolContract_OrderBy["Asset"] = "asset";
    LiquidityPoolContract_OrderBy["BetsAmount"] = "betsAmount";
    LiquidityPoolContract_OrderBy["BetsCount"] = "betsCount";
    LiquidityPoolContract_OrderBy["ChainId"] = "chainId";
    LiquidityPoolContract_OrderBy["ChainName"] = "chainName";
    LiquidityPoolContract_OrderBy["CoreAddresses"] = "coreAddresses";
    LiquidityPoolContract_OrderBy["Cores"] = "cores";
    LiquidityPoolContract_OrderBy["DaysSinceDeployment"] = "daysSinceDeployment";
    LiquidityPoolContract_OrderBy["DepositedAmount"] = "depositedAmount";
    LiquidityPoolContract_OrderBy["DepositedWithStakingAmount"] = "depositedWithStakingAmount";
    LiquidityPoolContract_OrderBy["FirstCalculatedBlockNumber"] = "firstCalculatedBlockNumber";
    LiquidityPoolContract_OrderBy["FirstCalculatedBlockTimestamp"] = "firstCalculatedBlockTimestamp";
    LiquidityPoolContract_OrderBy["Id"] = "id";
    LiquidityPoolContract_OrderBy["LastCalculatedBlockNumber"] = "lastCalculatedBlockNumber";
    LiquidityPoolContract_OrderBy["LastCalculatedBlockTimestamp"] = "lastCalculatedBlockTimestamp";
    LiquidityPoolContract_OrderBy["LiquidityManager"] = "liquidityManager";
    LiquidityPoolContract_OrderBy["Nfts"] = "nfts";
    LiquidityPoolContract_OrderBy["RawApr"] = "rawApr";
    LiquidityPoolContract_OrderBy["RawTvl"] = "rawTvl";
    LiquidityPoolContract_OrderBy["Token"] = "token";
    LiquidityPoolContract_OrderBy["TokenDecimals"] = "tokenDecimals";
    LiquidityPoolContract_OrderBy["Tvl"] = "tvl";
    LiquidityPoolContract_OrderBy["Type"] = "type";
    LiquidityPoolContract_OrderBy["VaultAddress"] = "vaultAddress";
    LiquidityPoolContract_OrderBy["WithdrawTimeout"] = "withdrawTimeout";
    LiquidityPoolContract_OrderBy["WithdrawnAmount"] = "withdrawnAmount";
    LiquidityPoolContract_OrderBy["WithdrawnWithStakingAmount"] = "withdrawnWithStakingAmount";
    LiquidityPoolContract_OrderBy["WonBetsAmount"] = "wonBetsAmount";
    LiquidityPoolContract_OrderBy["WonBetsCount"] = "wonBetsCount";
})(LiquidityPoolContract_OrderBy || (LiquidityPoolContract_OrderBy = {}));
var LiquidityPoolNft_OrderBy;
(function (LiquidityPoolNft_OrderBy) {
    LiquidityPoolNft_OrderBy["CreateBlockNumber"] = "createBlockNumber";
    LiquidityPoolNft_OrderBy["CreateBlockTimestamp"] = "createBlockTimestamp";
    LiquidityPoolNft_OrderBy["DepositedAmount"] = "depositedAmount";
    LiquidityPoolNft_OrderBy["HistoricalOwners"] = "historicalOwners";
    LiquidityPoolNft_OrderBy["Id"] = "id";
    LiquidityPoolNft_OrderBy["IsFullyWithdrawn"] = "isFullyWithdrawn";
    LiquidityPoolNft_OrderBy["LiquidityPool"] = "liquidityPool";
    LiquidityPoolNft_OrderBy["NftId"] = "nftId";
    LiquidityPoolNft_OrderBy["Owner"] = "owner";
    LiquidityPoolNft_OrderBy["RawDepositedAmount"] = "rawDepositedAmount";
    LiquidityPoolNft_OrderBy["RawWithdrawnAmount"] = "rawWithdrawnAmount";
    LiquidityPoolNft_OrderBy["Transactions"] = "transactions";
    LiquidityPoolNft_OrderBy["WithdrawTimeout"] = "withdrawTimeout";
    LiquidityPoolNft_OrderBy["WithdrawnAmount"] = "withdrawnAmount";
})(LiquidityPoolNft_OrderBy || (LiquidityPoolNft_OrderBy = {}));
var LiquidityPoolTransactionType;
(function (LiquidityPoolTransactionType) {
    LiquidityPoolTransactionType["Deposit"] = "Deposit";
    LiquidityPoolTransactionType["Withdrawal"] = "Withdrawal";
})(LiquidityPoolTransactionType || (LiquidityPoolTransactionType = {}));
var LiquidityPoolTransaction_OrderBy;
(function (LiquidityPoolTransaction_OrderBy) {
    LiquidityPoolTransaction_OrderBy["Account"] = "account";
    LiquidityPoolTransaction_OrderBy["Amount"] = "amount";
    LiquidityPoolTransaction_OrderBy["BlockNumber"] = "blockNumber";
    LiquidityPoolTransaction_OrderBy["BlockTimestamp"] = "blockTimestamp";
    LiquidityPoolTransaction_OrderBy["Id"] = "id";
    LiquidityPoolTransaction_OrderBy["LiquidityPool"] = "liquidityPool";
    LiquidityPoolTransaction_OrderBy["Nft"] = "nft";
    LiquidityPoolTransaction_OrderBy["RawAmount"] = "rawAmount";
    LiquidityPoolTransaction_OrderBy["TxHash"] = "txHash";
    LiquidityPoolTransaction_OrderBy["Type"] = "type";
})(LiquidityPoolTransaction_OrderBy || (LiquidityPoolTransaction_OrderBy = {}));
var LiveBet_OrderBy;
(function (LiveBet_OrderBy) {
    LiveBet_OrderBy["CanceledSubBetsCount"] = "_canceledSubBetsCount";
    LiveBet_OrderBy["ConditionIds"] = "_conditionIds";
    LiveBet_OrderBy["Conditions"] = "_conditions";
    LiveBet_OrderBy["GamesIds"] = "_gamesIds";
    LiveBet_OrderBy["IsFreebet"] = "_isFreebet";
    LiveBet_OrderBy["LostSubBetsCount"] = "_lostSubBetsCount";
    LiveBet_OrderBy["MarginsForSettle"] = "_marginsForSettle";
    LiveBet_OrderBy["OddsDecimals"] = "_oddsDecimals";
    LiveBet_OrderBy["SubBetsCount"] = "_subBetsCount";
    LiveBet_OrderBy["TokenDecimals"] = "_tokenDecimals";
    LiveBet_OrderBy["UpdatedAt"] = "_updatedAt";
    LiveBet_OrderBy["WonSubBetsCount"] = "_wonSubBetsCount";
    LiveBet_OrderBy["Actor"] = "actor";
    LiveBet_OrderBy["Affiliate"] = "affiliate";
    LiveBet_OrderBy["Amount"] = "amount";
    LiveBet_OrderBy["BetId"] = "betId";
    LiveBet_OrderBy["Bettor"] = "bettor";
    LiveBet_OrderBy["Cashout"] = "cashout";
    LiveBet_OrderBy["Core"] = "core";
    LiveBet_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    LiveBet_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    LiveBet_OrderBy["CreatedTxHash"] = "createdTxHash";
    LiveBet_OrderBy["Freebet"] = "freebet";
    LiveBet_OrderBy["Id"] = "id";
    LiveBet_OrderBy["IsCashedOut"] = "isCashedOut";
    LiveBet_OrderBy["IsRedeemable"] = "isRedeemable";
    LiveBet_OrderBy["IsRedeemed"] = "isRedeemed";
    LiveBet_OrderBy["Nonce"] = "nonce";
    LiveBet_OrderBy["Odds"] = "odds";
    LiveBet_OrderBy["Owner"] = "owner";
    LiveBet_OrderBy["Payout"] = "payout";
    LiveBet_OrderBy["PayoutLimit"] = "payoutLimit";
    LiveBet_OrderBy["PotentialPayout"] = "potentialPayout";
    LiveBet_OrderBy["RawAmount"] = "rawAmount";
    LiveBet_OrderBy["RawOdds"] = "rawOdds";
    LiveBet_OrderBy["RawPayout"] = "rawPayout";
    LiveBet_OrderBy["RawPayoutLimit"] = "rawPayoutLimit";
    LiveBet_OrderBy["RawPotentialPayout"] = "rawPotentialPayout";
    LiveBet_OrderBy["RawSettledMargin"] = "rawSettledMargin";
    LiveBet_OrderBy["RawSettledOdds"] = "rawSettledOdds";
    LiveBet_OrderBy["RedeemedBlockNumber"] = "redeemedBlockNumber";
    LiveBet_OrderBy["RedeemedBlockTimestamp"] = "redeemedBlockTimestamp";
    LiveBet_OrderBy["RedeemedTxHash"] = "redeemedTxHash";
    LiveBet_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    LiveBet_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    LiveBet_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    LiveBet_OrderBy["Result"] = "result";
    LiveBet_OrderBy["Selections"] = "selections";
    LiveBet_OrderBy["SettledMargin"] = "settledMargin";
    LiveBet_OrderBy["SettledOdds"] = "settledOdds";
    LiveBet_OrderBy["Status"] = "status";
})(LiveBet_OrderBy || (LiveBet_OrderBy = {}));
var LiveCondition_OrderBy;
(function (LiveCondition_OrderBy) {
    LiveCondition_OrderBy["UpdatedAt"] = "_updatedAt";
    LiveCondition_OrderBy["WinningOutcomesCount"] = "_winningOutcomesCount";
    LiveCondition_OrderBy["ConditionId"] = "conditionId";
    LiveCondition_OrderBy["Core"] = "core";
    LiveCondition_OrderBy["CoreAddress"] = "coreAddress";
    LiveCondition_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    LiveCondition_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    LiveCondition_OrderBy["CreatedTxHash"] = "createdTxHash";
    LiveCondition_OrderBy["GameId"] = "gameId";
    LiveCondition_OrderBy["Hidden"] = "hidden";
    LiveCondition_OrderBy["Id"] = "id";
    LiveCondition_OrderBy["Outcomes"] = "outcomes";
    LiveCondition_OrderBy["OutcomesIds"] = "outcomesIds";
    LiveCondition_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    LiveCondition_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    LiveCondition_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    LiveCondition_OrderBy["Status"] = "status";
    LiveCondition_OrderBy["Title"] = "title";
    LiveCondition_OrderBy["Turnover"] = "turnover";
    LiveCondition_OrderBy["WonOutcomeIds"] = "wonOutcomeIds";
    LiveCondition_OrderBy["WonOutcomes"] = "wonOutcomes";
})(LiveCondition_OrderBy || (LiveCondition_OrderBy = {}));
var LiveOutcome_OrderBy;
(function (LiveOutcome_OrderBy) {
    LiveOutcome_OrderBy["BetsEntityIds"] = "_betsEntityIds";
    LiveOutcome_OrderBy["UpdatedAt"] = "_updatedAt";
    LiveOutcome_OrderBy["Condition"] = "condition";
    LiveOutcome_OrderBy["Core"] = "core";
    LiveOutcome_OrderBy["Id"] = "id";
    LiveOutcome_OrderBy["OutcomeId"] = "outcomeId";
    LiveOutcome_OrderBy["Result"] = "result";
    LiveOutcome_OrderBy["Selections"] = "selections";
    LiveOutcome_OrderBy["SortOrder"] = "sortOrder";
    LiveOutcome_OrderBy["Title"] = "title";
})(LiveOutcome_OrderBy || (LiveOutcome_OrderBy = {}));
var LiveSelection_OrderBy;
(function (LiveSelection_OrderBy) {
    LiveSelection_OrderBy["OddsDecimals"] = "_oddsDecimals";
    LiveSelection_OrderBy["OutcomeId"] = "_outcomeId";
    LiveSelection_OrderBy["Bet"] = "bet";
    LiveSelection_OrderBy["Id"] = "id";
    LiveSelection_OrderBy["Margin"] = "margin";
    LiveSelection_OrderBy["Odds"] = "odds";
    LiveSelection_OrderBy["Outcome"] = "outcome";
    LiveSelection_OrderBy["RawMargin"] = "rawMargin";
    LiveSelection_OrderBy["RawOdds"] = "rawOdds";
    LiveSelection_OrderBy["Result"] = "result";
})(LiveSelection_OrderBy || (LiveSelection_OrderBy = {}));
/** Defines the order direction, either ascending or descending */
var OrderDirection$1;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection$1 || (OrderDirection$1 = {}));
var OutcomeResult$1;
(function (OutcomeResult) {
    OutcomeResult["Lost"] = "Lost";
    OutcomeResult["Won"] = "Won";
})(OutcomeResult$1 || (OutcomeResult$1 = {}));
var Outcome_OrderBy$1;
(function (Outcome_OrderBy) {
    Outcome_OrderBy["BetsEntityIds"] = "_betsEntityIds";
    Outcome_OrderBy["UpdatedAt"] = "_updatedAt";
    Outcome_OrderBy["Condition"] = "condition";
    Outcome_OrderBy["Core"] = "core";
    Outcome_OrderBy["CurrentOdds"] = "currentOdds";
    Outcome_OrderBy["Fund"] = "fund";
    Outcome_OrderBy["Id"] = "id";
    Outcome_OrderBy["OutcomeId"] = "outcomeId";
    Outcome_OrderBy["RawCurrentOdds"] = "rawCurrentOdds";
    Outcome_OrderBy["Result"] = "result";
    Outcome_OrderBy["Selections"] = "selections";
    Outcome_OrderBy["SortOrder"] = "sortOrder";
    Outcome_OrderBy["Title"] = "title";
})(Outcome_OrderBy$1 || (Outcome_OrderBy$1 = {}));
var OutcomesKeyConditionRelation_OrderBy;
(function (OutcomesKeyConditionRelation_OrderBy) {
    OutcomesKeyConditionRelation_OrderBy["ConditionEntityId"] = "conditionEntityId";
    OutcomesKeyConditionRelation_OrderBy["Id"] = "id";
})(OutcomesKeyConditionRelation_OrderBy || (OutcomesKeyConditionRelation_OrderBy = {}));
var Participant_OrderBy$1;
(function (Participant_OrderBy) {
    Participant_OrderBy["Game"] = "game";
    Participant_OrderBy["Id"] = "id";
    Participant_OrderBy["Image"] = "image";
    Participant_OrderBy["Name"] = "name";
    Participant_OrderBy["SortOrder"] = "sortOrder";
})(Participant_OrderBy$1 || (Participant_OrderBy$1 = {}));
var SelectionResult;
(function (SelectionResult) {
    SelectionResult["Lost"] = "Lost";
    SelectionResult["Won"] = "Won";
})(SelectionResult || (SelectionResult = {}));
var Selection_OrderBy;
(function (Selection_OrderBy) {
    Selection_OrderBy["OddsDecimals"] = "_oddsDecimals";
    Selection_OrderBy["OutcomeId"] = "_outcomeId";
    Selection_OrderBy["Bet"] = "bet";
    Selection_OrderBy["Id"] = "id";
    Selection_OrderBy["Margin"] = "margin";
    Selection_OrderBy["Odds"] = "odds";
    Selection_OrderBy["Outcome"] = "outcome";
    Selection_OrderBy["RawMargin"] = "rawMargin";
    Selection_OrderBy["RawOdds"] = "rawOdds";
    Selection_OrderBy["Result"] = "result";
})(Selection_OrderBy || (Selection_OrderBy = {}));
var SportHub_OrderBy$1;
(function (SportHub_OrderBy) {
    SportHub_OrderBy["Id"] = "id";
    SportHub_OrderBy["Name"] = "name";
    SportHub_OrderBy["Slug"] = "slug";
    SportHub_OrderBy["Sports"] = "sports";
})(SportHub_OrderBy$1 || (SportHub_OrderBy$1 = {}));
var Sport_OrderBy$1;
(function (Sport_OrderBy) {
    Sport_OrderBy["Countries"] = "countries";
    Sport_OrderBy["Games"] = "games";
    Sport_OrderBy["Id"] = "id";
    Sport_OrderBy["Name"] = "name";
    Sport_OrderBy["Slug"] = "slug";
    Sport_OrderBy["SportId"] = "sportId";
    Sport_OrderBy["Sporthub"] = "sporthub";
})(Sport_OrderBy$1 || (Sport_OrderBy$1 = {}));
var V3_BetMetadata_OrderBy;
(function (V3_BetMetadata_OrderBy) {
    V3_BetMetadata_OrderBy["FreebetId"] = "freebetId";
    V3_BetMetadata_OrderBy["FreebetOwner"] = "freebetOwner";
    V3_BetMetadata_OrderBy["Id"] = "id";
    V3_BetMetadata_OrderBy["IsFeeSponsored"] = "isFeeSponsored";
    V3_BetMetadata_OrderBy["IsFreebet"] = "isFreebet";
    V3_BetMetadata_OrderBy["IsFreebetAmountReturnable"] = "isFreebetAmountReturnable";
    V3_BetMetadata_OrderBy["PaymasterContractAddress"] = "paymasterContractAddress";
    V3_BetMetadata_OrderBy["RawRelayerFeeAmount"] = "rawRelayerFeeAmount";
})(V3_BetMetadata_OrderBy || (V3_BetMetadata_OrderBy = {}));
var V3_Bet_OrderBy;
(function (V3_Bet_OrderBy) {
    V3_Bet_OrderBy["CanceledSubBetsCount"] = "_canceledSubBetsCount";
    V3_Bet_OrderBy["ConditionIds"] = "_conditionIds";
    V3_Bet_OrderBy["Conditions"] = "_conditions";
    V3_Bet_OrderBy["GamesIds"] = "_gamesIds";
    V3_Bet_OrderBy["LostSubBetsCount"] = "_lostSubBetsCount";
    V3_Bet_OrderBy["OddsDecimals"] = "_oddsDecimals";
    V3_Bet_OrderBy["SubBetsCount"] = "_subBetsCount";
    V3_Bet_OrderBy["TokenDecimals"] = "_tokenDecimals";
    V3_Bet_OrderBy["UpdatedAt"] = "_updatedAt";
    V3_Bet_OrderBy["WonSubBetsCount"] = "_wonSubBetsCount";
    V3_Bet_OrderBy["Actor"] = "actor";
    V3_Bet_OrderBy["Affiliate"] = "affiliate";
    V3_Bet_OrderBy["Amount"] = "amount";
    V3_Bet_OrderBy["BetId"] = "betId";
    V3_Bet_OrderBy["Bettor"] = "bettor";
    V3_Bet_OrderBy["Cashout"] = "cashout";
    V3_Bet_OrderBy["Core"] = "core";
    V3_Bet_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    V3_Bet_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    V3_Bet_OrderBy["CreatedTxHash"] = "createdTxHash";
    V3_Bet_OrderBy["Freebet"] = "freebet";
    V3_Bet_OrderBy["FreebetId"] = "freebetId";
    V3_Bet_OrderBy["FreebetOwner"] = "freebetOwner";
    V3_Bet_OrderBy["Id"] = "id";
    V3_Bet_OrderBy["IsCashedOut"] = "isCashedOut";
    V3_Bet_OrderBy["IsFeeSponsored"] = "isFeeSponsored";
    V3_Bet_OrderBy["IsFreebet"] = "isFreebet";
    V3_Bet_OrderBy["IsFreebetAmountReturnable"] = "isFreebetAmountReturnable";
    V3_Bet_OrderBy["IsRedeemable"] = "isRedeemable";
    V3_Bet_OrderBy["IsRedeemed"] = "isRedeemed";
    V3_Bet_OrderBy["Nonce"] = "nonce";
    V3_Bet_OrderBy["Odds"] = "odds";
    V3_Bet_OrderBy["Owner"] = "owner";
    V3_Bet_OrderBy["PaymasterContractAddress"] = "paymasterContractAddress";
    V3_Bet_OrderBy["Payout"] = "payout";
    V3_Bet_OrderBy["PotentialLossLimit"] = "potentialLossLimit";
    V3_Bet_OrderBy["PotentialPayout"] = "potentialPayout";
    V3_Bet_OrderBy["RawAmount"] = "rawAmount";
    V3_Bet_OrderBy["RawOdds"] = "rawOdds";
    V3_Bet_OrderBy["RawPayout"] = "rawPayout";
    V3_Bet_OrderBy["RawPotentialLossLimit"] = "rawPotentialLossLimit";
    V3_Bet_OrderBy["RawPotentialPayout"] = "rawPotentialPayout";
    V3_Bet_OrderBy["RawRelayerFeeAmount"] = "rawRelayerFeeAmount";
    V3_Bet_OrderBy["RawSettledOdds"] = "rawSettledOdds";
    V3_Bet_OrderBy["RedeemedBlockNumber"] = "redeemedBlockNumber";
    V3_Bet_OrderBy["RedeemedBlockTimestamp"] = "redeemedBlockTimestamp";
    V3_Bet_OrderBy["RedeemedTxHash"] = "redeemedTxHash";
    V3_Bet_OrderBy["RelayerFeeAmount"] = "relayerFeeAmount";
    V3_Bet_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    V3_Bet_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    V3_Bet_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    V3_Bet_OrderBy["Result"] = "result";
    V3_Bet_OrderBy["Selections"] = "selections";
    V3_Bet_OrderBy["SettledOdds"] = "settledOdds";
    V3_Bet_OrderBy["Status"] = "status";
    V3_Bet_OrderBy["Type"] = "type";
})(V3_Bet_OrderBy || (V3_Bet_OrderBy = {}));
var V3_Condition_OrderBy;
(function (V3_Condition_OrderBy) {
    V3_Condition_OrderBy["UpdatedAt"] = "_updatedAt";
    V3_Condition_OrderBy["WinningOutcomesCount"] = "_winningOutcomesCount";
    V3_Condition_OrderBy["ConditionId"] = "conditionId";
    V3_Condition_OrderBy["Core"] = "core";
    V3_Condition_OrderBy["CoreAddress"] = "coreAddress";
    V3_Condition_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    V3_Condition_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    V3_Condition_OrderBy["CreatedTxHash"] = "createdTxHash";
    V3_Condition_OrderBy["GameId"] = "gameId";
    V3_Condition_OrderBy["Id"] = "id";
    V3_Condition_OrderBy["Outcomes"] = "outcomes";
    V3_Condition_OrderBy["OutcomesIds"] = "outcomesIds";
    V3_Condition_OrderBy["ResolvedBlockNumber"] = "resolvedBlockNumber";
    V3_Condition_OrderBy["ResolvedBlockTimestamp"] = "resolvedBlockTimestamp";
    V3_Condition_OrderBy["ResolvedTxHash"] = "resolvedTxHash";
    V3_Condition_OrderBy["Status"] = "status";
    V3_Condition_OrderBy["Title"] = "title";
    V3_Condition_OrderBy["Turnover"] = "turnover";
    V3_Condition_OrderBy["WonOutcomeIds"] = "wonOutcomeIds";
    V3_Condition_OrderBy["WonOutcomes"] = "wonOutcomes";
})(V3_Condition_OrderBy || (V3_Condition_OrderBy = {}));
var V3_Outcome_OrderBy;
(function (V3_Outcome_OrderBy) {
    V3_Outcome_OrderBy["BetsEntityIds"] = "_betsEntityIds";
    V3_Outcome_OrderBy["UpdatedAt"] = "_updatedAt";
    V3_Outcome_OrderBy["Condition"] = "condition";
    V3_Outcome_OrderBy["Core"] = "core";
    V3_Outcome_OrderBy["Id"] = "id";
    V3_Outcome_OrderBy["OutcomeId"] = "outcomeId";
    V3_Outcome_OrderBy["Result"] = "result";
    V3_Outcome_OrderBy["Selections"] = "selections";
    V3_Outcome_OrderBy["SortOrder"] = "sortOrder";
    V3_Outcome_OrderBy["Title"] = "title";
})(V3_Outcome_OrderBy || (V3_Outcome_OrderBy = {}));
var V3_SelectionConditionKind;
(function (V3_SelectionConditionKind) {
    V3_SelectionConditionKind["Live"] = "Live";
    V3_SelectionConditionKind["Prematch"] = "Prematch";
})(V3_SelectionConditionKind || (V3_SelectionConditionKind = {}));
var V3_Selection_OrderBy;
(function (V3_Selection_OrderBy) {
    V3_Selection_OrderBy["OddsDecimals"] = "_oddsDecimals";
    V3_Selection_OrderBy["OutcomeId"] = "_outcomeId";
    V3_Selection_OrderBy["Bet"] = "bet";
    V3_Selection_OrderBy["ConditionKind"] = "conditionKind";
    V3_Selection_OrderBy["Id"] = "id";
    V3_Selection_OrderBy["Odds"] = "odds";
    V3_Selection_OrderBy["Outcome"] = "outcome";
    V3_Selection_OrderBy["RawOdds"] = "rawOdds";
    V3_Selection_OrderBy["Result"] = "result";
})(V3_Selection_OrderBy || (V3_Selection_OrderBy = {}));
var _SubgraphErrorPolicy_$1;
(function (_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */
    _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */
    _SubgraphErrorPolicy_["Deny"] = "deny";
})(_SubgraphErrorPolicy_$1 || (_SubgraphErrorPolicy_$1 = {}));var Aggregation_Interval;
(function (Aggregation_Interval) {
    Aggregation_Interval["Day"] = "day";
    Aggregation_Interval["Hour"] = "hour";
})(Aggregation_Interval || (Aggregation_Interval = {}));
var ConditionState;
(function (ConditionState) {
    ConditionState["Active"] = "Active";
    ConditionState["Canceled"] = "Canceled";
    ConditionState["Removed"] = "Removed";
    ConditionState["Resolved"] = "Resolved";
    ConditionState["Stopped"] = "Stopped";
})(ConditionState || (ConditionState = {}));
var Condition_OrderBy;
(function (Condition_OrderBy) {
    Condition_OrderBy["IsCustomSettings"] = "_isCustomSettings";
    Condition_OrderBy["MaxLiveConditionPotentialLoss"] = "_maxLiveConditionPotentialLoss";
    Condition_OrderBy["MaxLiveOutcomePotentialLoss"] = "_maxLiveOutcomePotentialLoss";
    Condition_OrderBy["UpdatedAt"] = "_updatedAt";
    Condition_OrderBy["ConditionId"] = "conditionId";
    Condition_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Condition_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Condition_OrderBy["CurrentConditionPotentialLoss"] = "currentConditionPotentialLoss";
    Condition_OrderBy["Description"] = "description";
    Condition_OrderBy["Game"] = "game";
    Condition_OrderBy["Id"] = "id";
    Condition_OrderBy["IsCashoutEnabled"] = "isCashoutEnabled";
    Condition_OrderBy["IsExpressForbidden"] = "isExpressForbidden";
    Condition_OrderBy["IsLiveEnabled"] = "isLiveEnabled";
    Condition_OrderBy["IsPrematchEnabled"] = "isPrematchEnabled";
    Condition_OrderBy["Margin"] = "margin";
    Condition_OrderBy["MaxConditionPotentialLoss"] = "maxConditionPotentialLoss";
    Condition_OrderBy["MaxOutcomePotentialLoss"] = "maxOutcomePotentialLoss";
    Condition_OrderBy["Outcomes"] = "outcomes";
    Condition_OrderBy["OutcomesIds"] = "outcomesIds";
    Condition_OrderBy["RawCurrentConditionPotentialLoss"] = "rawCurrentConditionPotentialLoss";
    Condition_OrderBy["RawMaxConditionPotentialLoss"] = "rawMaxConditionPotentialLoss";
    Condition_OrderBy["RawMaxOutcomePotentialLoss"] = "rawMaxOutcomePotentialLoss";
    Condition_OrderBy["RawTurnover"] = "rawTurnover";
    Condition_OrderBy["SettledBlockNumber"] = "settledBlockNumber";
    Condition_OrderBy["SettledBlockTimestamp"] = "settledBlockTimestamp";
    Condition_OrderBy["State"] = "state";
    Condition_OrderBy["Title"] = "title";
    Condition_OrderBy["Turnover"] = "turnover";
    Condition_OrderBy["WinningOutcomesCount"] = "winningOutcomesCount";
    Condition_OrderBy["WonOutcomeIds"] = "wonOutcomeIds";
    Condition_OrderBy["WonOutcomes"] = "wonOutcomes";
})(Condition_OrderBy || (Condition_OrderBy = {}));
var Country_OrderBy;
(function (Country_OrderBy) {
    Country_OrderBy["ActiveGamesCount"] = "activeGamesCount";
    Country_OrderBy["ActiveLeaguesCount"] = "activeLeaguesCount";
    Country_OrderBy["ActiveLiveGamesCount"] = "activeLiveGamesCount";
    Country_OrderBy["ActiveLiveLeaguesCount"] = "activeLiveLeaguesCount";
    Country_OrderBy["ActivePrematchGamesCount"] = "activePrematchGamesCount";
    Country_OrderBy["ActivePrematchLeaguesCount"] = "activePrematchLeaguesCount";
    Country_OrderBy["Games"] = "games";
    Country_OrderBy["Id"] = "id";
    Country_OrderBy["Leagues"] = "leagues";
    Country_OrderBy["Name"] = "name";
    Country_OrderBy["RawTotalTurnover"] = "rawTotalTurnover";
    Country_OrderBy["RawTurnover"] = "rawTurnover";
    Country_OrderBy["Slug"] = "slug";
    Country_OrderBy["Sport"] = "sport";
    Country_OrderBy["TotalTurnover"] = "totalTurnover";
    Country_OrderBy["Turnover"] = "turnover";
})(Country_OrderBy || (Country_OrderBy = {}));
var EventName;
(function (EventName) {
    EventName["ConditionCreated"] = "ConditionCreated";
    EventName["ConditionUpdated"] = "ConditionUpdated";
    EventName["GameCreated"] = "GameCreated";
    EventName["GameUpdated"] = "GameUpdated";
})(EventName || (EventName = {}));
var Event_OrderBy;
(function (Event_OrderBy) {
    Event_OrderBy["BlockNumber"] = "blockNumber";
    Event_OrderBy["BlockTimestamp"] = "blockTimestamp";
    Event_OrderBy["ConditionId"] = "conditionId";
    Event_OrderBy["GameId"] = "gameId";
    Event_OrderBy["Id"] = "id";
    Event_OrderBy["Name"] = "name";
})(Event_OrderBy || (Event_OrderBy = {}));
var GameState;
(function (GameState) {
    GameState["Finished"] = "Finished";
    GameState["Live"] = "Live";
    GameState["Prematch"] = "Prematch";
    GameState["Stopped"] = "Stopped";
})(GameState || (GameState = {}));
var Game_OrderBy;
(function (Game_OrderBy) {
    Game_OrderBy["ProviderTitle"] = "_providerTitle";
    Game_OrderBy["UpdatedAt"] = "_updatedAt";
    Game_OrderBy["ActiveAndStoppedConditionsCount"] = "activeAndStoppedConditionsCount";
    Game_OrderBy["ActiveConditionsCount"] = "activeConditionsCount";
    Game_OrderBy["Conditions"] = "conditions";
    Game_OrderBy["ConditionsCount"] = "conditionsCount";
    Game_OrderBy["Country"] = "country";
    Game_OrderBy["CreatedBlockNumber"] = "createdBlockNumber";
    Game_OrderBy["CreatedBlockTimestamp"] = "createdBlockTimestamp";
    Game_OrderBy["Description"] = "description";
    Game_OrderBy["FinishedBlockNumber"] = "finishedBlockNumber";
    Game_OrderBy["FinishedBlockTimestamp"] = "finishedBlockTimestamp";
    Game_OrderBy["GameId"] = "gameId";
    Game_OrderBy["Id"] = "id";
    Game_OrderBy["League"] = "league";
    Game_OrderBy["Participants"] = "participants";
    Game_OrderBy["RawTotalTurnover"] = "rawTotalTurnover";
    Game_OrderBy["RawTurnover"] = "rawTurnover";
    Game_OrderBy["SettledBlockNumber"] = "settledBlockNumber";
    Game_OrderBy["SettledBlockTimestamp"] = "settledBlockTimestamp";
    Game_OrderBy["SettledConditionsCount"] = "settledConditionsCount";
    Game_OrderBy["Slug"] = "slug";
    Game_OrderBy["Sport"] = "sport";
    Game_OrderBy["StartsAt"] = "startsAt";
    Game_OrderBy["State"] = "state";
    Game_OrderBy["Title"] = "title";
    Game_OrderBy["TotalTurnover"] = "totalTurnover";
    Game_OrderBy["Turnover"] = "turnover";
})(Game_OrderBy || (Game_OrderBy = {}));
var League_OrderBy;
(function (League_OrderBy) {
    League_OrderBy["ActiveGamesCount"] = "activeGamesCount";
    League_OrderBy["ActiveLiveGamesCount"] = "activeLiveGamesCount";
    League_OrderBy["ActivePrematchGamesCount"] = "activePrematchGamesCount";
    League_OrderBy["Country"] = "country";
    League_OrderBy["Games"] = "games";
    League_OrderBy["Id"] = "id";
    League_OrderBy["Name"] = "name";
    League_OrderBy["RawTotalTurnover"] = "rawTotalTurnover";
    League_OrderBy["RawTurnover"] = "rawTurnover";
    League_OrderBy["Slug"] = "slug";
    League_OrderBy["Sport"] = "sport";
    League_OrderBy["TotalTurnover"] = "totalTurnover";
    League_OrderBy["Turnover"] = "turnover";
})(League_OrderBy || (League_OrderBy = {}));
/** Defines the order direction, either ascending or descending */
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (OrderDirection = {}));
var OutcomeResult;
(function (OutcomeResult) {
    OutcomeResult["Lost"] = "Lost";
    OutcomeResult["Won"] = "Won";
})(OutcomeResult || (OutcomeResult = {}));
var Outcome_OrderBy;
(function (Outcome_OrderBy) {
    Outcome_OrderBy["UpdatedAt"] = "_updatedAt";
    Outcome_OrderBy["Condition"] = "condition";
    Outcome_OrderBy["CurrentOdds"] = "currentOdds";
    Outcome_OrderBy["Id"] = "id";
    Outcome_OrderBy["OutcomeId"] = "outcomeId";
    Outcome_OrderBy["PotentialLoss"] = "potentialLoss";
    Outcome_OrderBy["RawCurrentOdds"] = "rawCurrentOdds";
    Outcome_OrderBy["RawPotentialLoss"] = "rawPotentialLoss";
    Outcome_OrderBy["RawTurnover"] = "rawTurnover";
    Outcome_OrderBy["Result"] = "result";
    Outcome_OrderBy["SortOrder"] = "sortOrder";
    Outcome_OrderBy["Title"] = "title";
    Outcome_OrderBy["Turnover"] = "turnover";
})(Outcome_OrderBy || (Outcome_OrderBy = {}));
var Participant_OrderBy;
(function (Participant_OrderBy) {
    Participant_OrderBy["Game"] = "game";
    Participant_OrderBy["Id"] = "id";
    Participant_OrderBy["Image"] = "image";
    Participant_OrderBy["Name"] = "name";
    Participant_OrderBy["SortOrder"] = "sortOrder";
})(Participant_OrderBy || (Participant_OrderBy = {}));
var SportHub_OrderBy;
(function (SportHub_OrderBy) {
    SportHub_OrderBy["Id"] = "id";
    SportHub_OrderBy["Name"] = "name";
    SportHub_OrderBy["Slug"] = "slug";
    SportHub_OrderBy["Sports"] = "sports";
})(SportHub_OrderBy || (SportHub_OrderBy = {}));
var Sport_OrderBy;
(function (Sport_OrderBy) {
    Sport_OrderBy["ActiveCountriesCount"] = "activeCountriesCount";
    Sport_OrderBy["ActiveGamesCount"] = "activeGamesCount";
    Sport_OrderBy["ActiveLeaguesCount"] = "activeLeaguesCount";
    Sport_OrderBy["ActiveLiveCountriesCount"] = "activeLiveCountriesCount";
    Sport_OrderBy["ActiveLiveGamesCount"] = "activeLiveGamesCount";
    Sport_OrderBy["ActiveLiveLeaguesCount"] = "activeLiveLeaguesCount";
    Sport_OrderBy["ActivePrematchCountriesCount"] = "activePrematchCountriesCount";
    Sport_OrderBy["ActivePrematchGamesCount"] = "activePrematchGamesCount";
    Sport_OrderBy["ActivePrematchLeaguesCount"] = "activePrematchLeaguesCount";
    Sport_OrderBy["Countries"] = "countries";
    Sport_OrderBy["Games"] = "games";
    Sport_OrderBy["Id"] = "id";
    Sport_OrderBy["Leagues"] = "leagues";
    Sport_OrderBy["Name"] = "name";
    Sport_OrderBy["RawTotalTurnover"] = "rawTotalTurnover";
    Sport_OrderBy["RawTurnover"] = "rawTurnover";
    Sport_OrderBy["Slug"] = "slug";
    Sport_OrderBy["SportId"] = "sportId";
    Sport_OrderBy["Sporthub"] = "sporthub";
    Sport_OrderBy["TotalTurnover"] = "totalTurnover";
    Sport_OrderBy["Turnover"] = "turnover";
})(Sport_OrderBy || (Sport_OrderBy = {}));
var VirtualCondition_OrderBy;
(function (VirtualCondition_OrderBy) {
    VirtualCondition_OrderBy["Data"] = "data";
    VirtualCondition_OrderBy["Game"] = "game";
    VirtualCondition_OrderBy["Id"] = "id";
})(VirtualCondition_OrderBy || (VirtualCondition_OrderBy = {}));
var VirtualGame_OrderBy;
(function (VirtualGame_OrderBy) {
    VirtualGame_OrderBy["Conditions"] = "conditions";
    VirtualGame_OrderBy["Id"] = "id";
})(VirtualGame_OrderBy || (VirtualGame_OrderBy = {}));
var _SubgraphErrorPolicy_;
(function (_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */
    _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */
    _SubgraphErrorPolicy_["Deny"] = "deny";
})(_SubgraphErrorPolicy_ || (_SubgraphErrorPolicy_ = {}));const CONDITION_PROVIDER_LENGTH = 3;
const getProviderFromId = (id) => {
    return +(id.slice(1, 1 + CONDITION_PROVIDER_LENGTH));
};const calcMindOdds = (props) => {
    const totalOdds = typeof props.odds === 'number' ? props.odds : props.odds.reduce((acc, odds) => acc * +odds, 1);
    const minOdds = 1 + (totalOdds - 1) * (100 - props.slippage) / 100;
    return minOdds.toFixed(ODDS_DECIMALS);
};const getIsPendingResolution = ({ state, startsAt }) => {
    if (state !== GameState.Live) {
        return false;
    }
    const startDate = +startsAt * 1000;
    const now = Date.now();
    const isStarted = startDate < now;
    const pendingResolutionDate = startDate + 6000000;
    return isStarted && pendingResolutionDate < now;
};var BetStatus;
(function (BetStatus) {
    BetStatus[BetStatus["Accepted"] = 0] = "Accepted";
    BetStatus[BetStatus["Live"] = 1] = "Live";
    BetStatus[BetStatus["PendingResolution"] = 2] = "PendingResolution";
    BetStatus[BetStatus["Resolved"] = 3] = "Resolved";
    BetStatus[BetStatus["Canceled"] = 4] = "Canceled";
})(BetStatus || (BetStatus = {}));
const getExpressIsPendingResolution = (games) => {
    const lastStartDate = Math.max(...games.map(({ startsAt }) => +startsAt));
    const lastGames = games.filter(({ startsAt }) => +startsAt === lastStartDate);
    return lastGames.some((game) => {
        return getIsPendingResolution(game);
    });
};
const getBetStatus = (props) => {
    const { games, graphStatus } = props;
    if (graphStatus === BetStatus$1.Canceled) {
        return BetStatus.Canceled;
    }
    if (graphStatus === BetStatus$1.Resolved) {
        return BetStatus.Resolved;
    }
    const isExpress = games.length > 1;
    const isPendingResolution = isExpress
        ? getExpressIsPendingResolution(games)
        : getIsPendingResolution(games[0]);
    if (isPendingResolution) {
        return BetStatus.PendingResolution;
    }
    const isLive = games.some(game => game.state === GameState.Live);
    if (isLive) {
        return BetStatus.Live;
    }
    return BetStatus.Accepted;
};const getBetFee = async (chainId) => {
    const api = getApiEndpoint(chainId);
    const environment = environments[chainId];
    const response = await fetch(`${api}/bet/gas-info?environment=${environment}`);
    const data = await response.json();
    return data;
};const groupConditionsByMarket = (conditions) => {
    const sportId = conditions[0].game.sport.sportId;
    const markets = {};
    const stateByOutcomeIds = {};
    for (let conditionIndex = 0; conditionIndex < conditions.length; conditionIndex++) {
        const condition = conditions[conditionIndex];
        const { conditionId, outcomes: rawOutcomes, state, wonOutcomeIds, isExpressForbidden, title: customMarketName, margin, game: { gameId }, } = condition;
        const firstOutcomeId = rawOutcomes[0].outcomeId;
        const marketKey = getMarketKey(firstOutcomeId);
        const marketName = customMarketName && customMarketName !== 'null' ? customMarketName : getMarketName({ outcomeId: firstOutcomeId });
        const marketDescription = getMarketDescription({ outcomeId: firstOutcomeId });
        // start checking duplicates
        const key = rawOutcomes.map(({ outcomeId }) => outcomeId).join('-');
        if (stateByOutcomeIds[key]) {
            if (state === ConditionState.Stopped) {
                continue;
            }
            else if (stateByOutcomeIds[key].state === ConditionState.Stopped) {
                const removeConditionId = stateByOutcomeIds[key].conditionId;
                stateByOutcomeIds[key] = {
                    state,
                    conditionId,
                };
                delete markets[marketKey]?.conditions[removeConditionId];
            }
        }
        else {
            stateByOutcomeIds[key] = {
                state,
                conditionId,
            };
        }
        // end checking duplicates
        if (!markets[marketKey]) {
            markets[marketKey] = {
                name: marketName,
                marketKey,
                description: marketDescription,
                conditions: {},
            };
        }
        markets[marketKey].conditions[conditionId] = {
            conditionId,
            state,
            isExpressForbidden,
            margin,
            outcomes: [],
        };
        new Array(...rawOutcomes).sort((a, b) => {
            const { outcomes: dictionaryOutcomes } = dictionaries;
            const left = dictionaryOutcomes[String(a.outcomeId)].selectionId;
            const right = dictionaryOutcomes[String(b.outcomeId)].selectionId;
            return left - right;
        }).forEach((rawOutcome) => {
            const { outcomeId, odds, title: customSelectionName } = rawOutcome;
            const betTypeOdd = dictionaries.outcomes[outcomeId];
            if (!betTypeOdd) {
                console.warn(`betTypeOdd not found for "outcomeId: ${outcomeId}"`);
                return;
            }
            const selectionName = customSelectionName && customSelectionName !== 'null' ? customSelectionName : getSelectionName({ outcomeId, withPoint: true });
            const outcome = {
                conditionId,
                outcomeId,
                selectionName,
                gameId,
                isExpressForbidden,
                odds: +odds,
            };
            if (Array.isArray(wonOutcomeIds)) {
                outcome.isWon = wonOutcomeIds.includes(outcomeId);
            }
            markets[marketKey].conditions[conditionId].outcomes.push(outcome);
        });
    }
    const orderedMarketKeys = dictionaries.marketOrders?.[sportId];
    const result = Object.values(markets).map(market => {
        const { conditions } = market;
        return {
            ...market,
            conditions: Object.values(conditions).sort((a, b) => {
                const { points, outcomes: dictionaryOutcomes } = dictionaries;
                /*
                  we should always sort by param in first outcome
        
                  Handicap
                  Team 1 (-2.5)   Team 2 (2.5)
                  Team 1 (-1.5)   Team 2 (1.5)
        
                  Total Goals
                  Over (1.5)   Under (1.5)
                  Over (2.5)   Under (2.5)
                */
                const aPointId = dictionaryOutcomes[String(a.outcomes[0].outcomeId)].pointsId;
                const bPointId = dictionaryOutcomes[String(b.outcomes[0].outcomeId)].pointsId;
                const aFirstOutcome = +points[aPointId];
                const bFirstOutcome = +points[bPointId];
                return aFirstOutcome - bFirstOutcome;
            }),
        };
    });
    if (!orderedMarketKeys) {
        return result;
    }
    return [...result].sort((a, b) => {
        const prevMarketIndex = orderedMarketKeys.indexOf(a.marketKey);
        const nextMarketIndex = orderedMarketKeys.indexOf(b.marketKey);
        if (prevMarketIndex >= 0 && nextMarketIndex >= 0) {
            return prevMarketIndex - nextMarketIndex;
        }
        if (prevMarketIndex < 0 && nextMarketIndex >= 0) {
            return 1;
        }
        if (prevMarketIndex >= 0 && nextMarketIndex < 0) {
            return -1;
        }
        return 0;
    });
};const getBetTypedData = (props) => {
    const { account, clientData, bet } = props;
    const { chainId, core } = clientData;
    const EIP712Domain = {
        name: TYPED_DATA_DOMAIN_NAME,
        version: TYPED_DATA_DOMAIN_VERSION,
        chainId,
        verifyingContract: core,
    };
    return {
        account: account,
        domain: EIP712Domain,
        primaryType: 'ClientBetData',
        types: BET_DATA_TYPES,
        message: {
            clientData: {
                attention: clientData.attention,
                affiliate: clientData.affiliate,
                core: clientData.core,
                expiresAt: BigInt(clientData.expiresAt),
                chainId: BigInt(clientData.chainId),
                relayerFeeAmount: BigInt(clientData.relayerFeeAmount),
                isBetSponsored: clientData.isBetSponsored,
                isFeeSponsored: clientData.isFeeSponsored,
                isSponsoredBetReturnable: clientData.isSponsoredBetReturnable,
            },
            bets: [
                {
                    conditionId: BigInt(bet.conditionId),
                    outcomeId: BigInt(bet.outcomeId),
                    minOdds: BigInt(bet.minOdds),
                    amount: BigInt(bet.amount),
                    nonce: BigInt(bet.nonce),
                },
            ],
        },
    };
};const getComboBetTypedData = (props) => {
    const { account, amount, minOdds, nonce, clientData, bets } = props;
    const { chainId, core } = clientData;
    const EIP712Domain = {
        name: TYPED_DATA_DOMAIN_NAME,
        version: TYPED_DATA_DOMAIN_VERSION,
        chainId,
        verifyingContract: core,
    };
    return {
        account: account,
        domain: EIP712Domain,
        primaryType: 'ClientComboBetData',
        types: COMBO_BET_DATA_TYPES,
        message: {
            amount: BigInt(amount),
            minOdds: BigInt(minOdds),
            nonce: BigInt(nonce),
            clientData: {
                attention: clientData.attention,
                affiliate: clientData.affiliate,
                core: clientData.core,
                expiresAt: BigInt(clientData.expiresAt),
                chainId: BigInt(clientData.chainId),
                relayerFeeAmount: BigInt(clientData.relayerFeeAmount),
                isBetSponsored: clientData.isBetSponsored,
                isFeeSponsored: clientData.isFeeSponsored,
                isSponsoredBetReturnable: clientData.isSponsoredBetReturnable,
            },
            bets: bets.map(bet => ({
                conditionId: BigInt(bet.conditionId),
                outcomeId: BigInt(bet.outcomeId),
            })),
        },
    };
};const createBet = async (props) => {
    const { account, clientData, bet, signature, bonusId } = props;
    const { chainId } = clientData;
    const { api, environment } = chainsData[chainId];
    const signedBet = {
        environment,
        bonusId,
        bettor: account.toLowerCase(),
        betOwner: account.toLowerCase(),
        clientBetData: {
            clientData,
            bet: {
                conditionId: String(bet.conditionId),
                outcomeId: Number(bet.outcomeId),
                minOdds: String(bet.minOdds),
                amount: String(bet.amount),
                nonce: String(bet.nonce),
            },
        },
        bettorSignature: signature,
    };
    const response = await fetch(`${api}/bet/orders/ordinar`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(signedBet),
    });
    if (response.status === 404) {
        return null;
    }
    const data = await response.json();
    if (!response.ok) {
        const error = new Error(data?.errorMessage || `Status: ${response.status}`);
        if (data?.error) {
            error.cause = new Error(data.error);
        }
        throw error;
    }
    return data;
};const createComboBet = async (props) => {
    const { account, amount, minOdds, nonce, clientData, bets, signature, bonusId } = props;
    const { chainId } = clientData;
    const { api, environment } = chainsData[chainId];
    const signedBet = {
        environment,
        bonusId,
        bettor: account.toLowerCase(),
        betOwner: account.toLowerCase(),
        clientBetData: {
            clientData,
            amount: String(amount),
            minOdds: String(minOdds),
            nonce: String(nonce),
            bets: bets.map(bet => ({
                conditionId: String(bet.conditionId),
                outcomeId: Number(bet.outcomeId),
            })),
        },
        bettorSignature: signature,
    };
    const response = await fetch(`${api}/bet/orders/combo`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(signedBet),
    });
    if (response.status === 404) {
        return null;
    }
    const data = await response.json();
    if (!response.ok) {
        const error = new Error(data?.errorMessage || `Status: ${response.status}`);
        if (data?.error) {
            error.cause = new Error(data.error);
        }
        throw error;
    }
    return data;
};const getBet = async ({ chainId, orderId }) => {
    const { api } = chainsData[chainId];
    const response = await fetch(`${api}/bet/orders/${orderId}`);
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};const getMaxBet = async (props) => {
    const { chainId, selections } = props;
    const { api, environment } = chainsData[chainId];
    const response = await fetch(`${api}/bet/calculation`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            bets: selections.map(({ conditionId, outcomeId }) => ({
                conditionId,
                outcomeId: +outcomeId,
            })),
            environment,
        }),
    });
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return data.response;
};var WaveLevelName;
(function (WaveLevelName) {
    WaveLevelName["Grey"] = "Grey";
    WaveLevelName["Mist"] = "Mist";
    WaveLevelName["Sky"] = "Sky";
    WaveLevelName["Blue"] = "Blue";
    WaveLevelName["Ultramarine"] = "Ultramarine";
    WaveLevelName["Bright"] = "Bright";
    WaveLevelName["Brilliant"] = "Brilliant";
    WaveLevelName["Royal"] = "Royal";
})(WaveLevelName || (WaveLevelName = {}));
const getWaveLevels = async ({ waveId, chainId } = { waveId: 'active', chainId: polygon.id }) => {
    const api = getApiEndpoint(chainId);
    const response = await fetch(`${api}/waves/${waveId}/levels`);
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return [...data].sort((a, b) => a.level - b.level);
};const getWaveStats = async ({ account, waveId = 'active', chainId = polygon.id }) => {
    const api = getApiEndpoint(chainId);
    const response = await fetch(`${api}/waves/${waveId}/participants/${account?.toLowerCase()}/stats`);
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};const getWavePeriods = async ({ waveId, chainId } = { waveId: 'active', chainId: polygon.id }) => {
    const api = getApiEndpoint(chainId);
    const response = await fetch(`${api}/waves/${waveId}/periods`);
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};const getWaveLeaderBoard = async (props = { waveId: 'active', chainId: polygon.id }) => {
    const { waveId, account, startsAt, chainId } = props;
    const api = getApiEndpoint(chainId);
    const baseUrl = `${api}/waves/${waveId}`;
    let endpoint = startsAt
        ? `${baseUrl}/periods/${startsAt}/leaderboard`
        : `${baseUrl}/leaderboard`;
    if (account) {
        endpoint += `?address=${account?.toLowerCase()}`;
    }
    const response = await fetch(endpoint);
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    if (startsAt) {
        return data.map((item) => {
            const { address, points, position, expectedPositionMultiplier } = item;
            const rawPoints = parseUnits(points, 12);
            const rawMultipliedPoints = parseUnits(points, 12) * parseUnits(expectedPositionMultiplier, 12);
            const bonusPoints = formatUnits(rawMultipliedPoints - rawPoints, 24);
            const totalMultipliedPoints = formatUnits(rawMultipliedPoints, 24);
            return {
                position,
                address,
                points,
                bonusPoints,
                totalMultipliedPoints,
                bonusMultiplier: +expectedPositionMultiplier,
                level: null,
                levelDescription: null,
            };
        });
    }
    return data.map((item) => {
        const { address, points, position, level, levelDescription, multipliedPoints: totalMultipliedPoints } = item;
        return {
            position,
            address,
            points,
            bonusPoints: null,
            bonusMultiplier: null,
            totalMultipliedPoints,
            level,
            levelDescription,
        };
    });
};const activateWave = async ({ account, waveId = 'active', chainId = polygon.id }) => {
    const api = getApiEndpoint(chainId);
    const response = await fetch(`${api}/waves/${waveId}/participants/${account?.toLowerCase()}/activate`);
    await response.json();
};const getPrecalculatedCashouts = async (props) => {
    const { chainId, conditionIds } = props;
    const { api, contracts } = chainsData[chainId];
    if (!contracts.cashout?.address) {
        throw new Error('provided chainId is not supported for cashout');
    }
    const response = await fetch(`${api}/cashout/get-available`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            conditionIds,
        }),
    });
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};const getCalculatedCashout = async (props) => {
    const { chainId, account, graphBetId } = props;
    const { api, environment, contracts } = chainsData[chainId];
    if (!contracts.cashout?.address) {
        throw new Error('provided chainId is not supported for cashout');
    }
    const response = await fetch(`${api}/cashout/get-calculation`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            environment,
            owner: account,
            betId: graphBetId,
        }),
    });
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const { owner, betId, ...rest } = await response.json();
    return {
        account: owner,
        tokenId: betId,
        ...rest,
    };
};const getCashoutTypedData = (props) => {
    const { account, chainId, attention, tokenId, cashoutOdds, expiredAt } = props;
    const { contracts } = chainsData[chainId];
    if (!contracts.cashout?.address) {
        throw new Error('provided chainId is not supported for cashout');
    }
    const EIP712Domain = {
        name: CASHOUT_TYPED_DATA_DOMAIN_NAME,
        version: CASHOUT_TYPED_DATA_DOMAIN_VERSION,
        chainId,
        verifyingContract: contracts.cashout.address,
    };
    return {
        account: account,
        domain: EIP712Domain,
        primaryType: 'CashOutOrder',
        types: CASHOUT_DATA_TYPES,
        message: {
            attention: attention || 'By signing this transaction, I agree to cash out on \'Azuro SDK Example',
            chainId: BigInt(chainId),
            items: [
                {
                    betId: BigInt(tokenId),
                    bettingContract: contracts.core.address,
                    minOdds: typeof cashoutOdds === 'string' ? (parseUnits(cashoutOdds, ODDS_DECIMALS)) : cashoutOdds,
                },
            ],
            expiresAt: BigInt(expiredAt),
        },
    };
};var CashoutState;
(function (CashoutState) {
    CashoutState["Processing"] = "PROCESSING";
    CashoutState["Accepted"] = "ACCEPTED";
    CashoutState["Rejected"] = "REJECTED";
    CashoutState["Open"] = "OPEN";
})(CashoutState || (CashoutState = {}));
const createCashout = async (props) => {
    const { chainId, calculationId, attention, signature } = props;
    const { api, contracts } = chainsData[chainId];
    if (!contracts.cashout?.address) {
        throw new Error('provided chainId is not supported for cashout');
    }
    const signedCashout = {
        calculationId,
        signature: {
            verifyingContract: contracts.cashout.address,
            bettingContract: contracts.core.address,
            attention,
            chainId,
            ownerSignature: signature,
        },
    };
    const response = await fetch(`${api}/cashout/create`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(signedCashout),
    });
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};const getCashout = async ({ chainId, orderId }) => {
    const { api, contracts } = chainsData[chainId];
    if (!contracts.cashout?.address) {
        throw new Error('provided chainId is not supported for cashout');
    }
    const response = await fetch(`${api}/cashout/${orderId}`);
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};const getBonuses = async (props) => {
    const { chainId, account, affiliate, bonusStatus = BonusStatus.Available } = props;
    const { api } = chainsData[chainId];
    const response = await fetch(`${api}/bonus/get-by-addresses`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            bettorAddress: account,
            poolAddress: affiliate,
            status: bonusStatus,
        }),
    });
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const { bonuses } = await response.json();
    return bonuses.reduce((acc, bonus) => {
        const environment = `${bonus.network}${bonus.currency}`;
        const { chain, betToken } = chainsDataByEnv[environment];
        // TODO: need to add environement to request params
        if (chain.id === chainId) {
            const { id, freebetParam: { isBetSponsored, isFeeSponsored, isSponsoredBetReturnable, settings, }, } = bonus;
            acc.push({
                id,
                amount: formatUnits(BigInt(bonus.amount), betToken.decimals),
                type: bonus.bonusType,
                params: {
                    isBetSponsored,
                    isFeeSponsored,
                    isSponsoredBetReturnable,
                },
                settings: {
                    type: settings.bonusType,
                    feeSponsored: settings.feeSponsored,
                    betRestriction: {
                        type: settings.betRestriction.betType === 'All' ? undefined : settings.betRestriction.betType,
                        minOdds: settings.betRestriction.minOdds,
                        maxOdds: settings.betRestriction?.maxOdds,
                    },
                    eventRestriction: {
                        state: settings.eventRestriction.eventStatus === 'All' ? undefined : settings.eventRestriction.eventStatus,
                    },
                    periodOfValidityMs: settings.periodOfValidityMs,
                },
                status: bonus.status,
                chainId: chain.id,
                expiresAt: +new Date(bonus.expiresAt),
                usedAt: +new Date(bonus.usedAt),
                createdAt: +new Date(bonus.createdAt),
            });
        }
        return acc;
    }, []);
};const getAvailableFreebets = async ({ chainId, account, affiliate, selections }) => {
    const { api, environment, betToken } = chainsData[chainId];
    const response = await fetch(`${api}/bonus/freebet/get-available`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            environment,
            bettorAddress: account,
            poolAddress: affiliate,
            selections: selections.map(selection => ({
                conditionId: selection.conditionId,
                outcomeId: +selection.outcomeId,
            })),
        }),
    });
    if (response.status === 404) {
        return null;
    }
    if (!response.ok) {
        throw new Error(`Status ${response.status}: ${response.statusText}`);
    }
    const { bonuses } = await response.json();
    return bonuses.map(bonus => {
        const environment = `${bonus.network}${bonus.currency}`;
        const { id, freebetParam: { isBetSponsored, isFeeSponsored, isSponsoredBetReturnable, settings, }, } = bonus;
        return {
            id,
            amount: formatUnits(BigInt(bonus.amount), betToken.decimals),
            type: BonusType.FreeBet,
            params: {
                isBetSponsored,
                isFeeSponsored,
                isSponsoredBetReturnable,
            },
            settings: {
                type: settings.bonusType,
                feeSponsored: settings.feeSponsored,
                betRestriction: {
                    type: settings.betRestriction.betType === 'All' ? undefined : settings.betRestriction.betType,
                    minOdds: settings.betRestriction.minOdds,
                    maxOdds: settings.betRestriction?.maxOdds,
                },
                eventRestriction: {
                    state: settings.eventRestriction.eventStatus === 'All' ? undefined : settings.eventRestriction.eventStatus,
                },
                periodOfValidityMs: settings.periodOfValidityMs,
            },
            status: bonus.status,
            chainId: chainsDataByEnv[environment].chain.id,
            expiresAt: +new Date(bonus.expiresAt),
            usedAt: +new Date(bonus.usedAt),
            createdAt: +new Date(bonus.createdAt),
        };
    });
};export{Aggregation_Interval,BET_DATA_TYPES,ConditionStatus as BetConditionStatus,BetFragmentDoc,BetRestrictionType,BetResult,BetState,BetStatus,V3_Bet_OrderBy as Bet_OrderBy,BetsDocument,BettorFragmentDoc,BettorsDocument,BonusStatus,BonusType,CASHOUT_DATA_TYPES,CASHOUT_TYPED_DATA_DOMAIN_NAME,CASHOUT_TYPED_DATA_DOMAIN_VERSION,CLIENT_DATA_TYPES,COMBO_BET_DATA_TYPES,CashoutState,ConditionDocument,ConditionFragmentDoc,ConditionState,Condition_OrderBy,ConditionsBatchDocument,ConditionsDocument,Country_OrderBy,Environment,EventName,EventRestrictionState,Event_OrderBy,FreebetType,GameBetsDocument,GameDocument,GameInfoFragmentDoc,GameState,Game_OrderBy,GamesDocument,BetStatus$1 as GraphBetStatus,League_OrderBy,LegacyBetsDocument,GameStatus as LegacyGameStatus,LegacyLiveBetFragmentDoc,LegacyLiveGamesDocument,LegacyPrematchBetFragmentDoc,Bet_OrderBy as Legacy_Bet_OrderBy,NavigationDocument,ODDS_DECIMALS,OrderDirection,OutcomeResult,Outcome_OrderBy,Participant_OrderBy,V3_SelectionConditionKind as SelectionKind,SelectionResult,SportHub_OrderBy,Sport_OrderBy,SportsDocument,SportsNavigationDocument,TYPED_DATA_DOMAIN_NAME,TYPED_DATA_DOMAIN_VERSION,VirtualCondition_OrderBy,VirtualGame_OrderBy,WaveLevelName,_SubgraphErrorPolicy_,activateWave,azuroBetAbi,baseData,baseSepoliaData,calcMindOdds,cashoutAbi,chainsData,chainsDataByEnv,chilizData,coreAbi,createBet,createCashout,createComboBet,environments,getApiEndpoint,getAvailableFreebets,getBet,getBetFee,getBetStatus,getBetTypedData,getBetsGraphqlEndpoint,getBonuses,getCalculatedCashout,getCashout,getCashoutTypedData,getComboBetTypedData,getFeedGraphqlEndpoint,getIsPendingResolution,getMaxBet,getPrecalculatedCashouts,getProviderFromId,getSocketEndpoint,getWaveLeaderBoard,getWaveLevels,getWavePeriods,getWaveStats,gnosisData,gnosisDevData,groupConditionsByMarket,lpAbi,paymasterAbi,polygonAmoyData,polygonData,relayerAbi,setupContracts,spicyData,vaultAbi};//# sourceMappingURL=index.js.map
